/*! For license information please see slider.js.LICENSE.txt */
(() => {
    "use strict";
    var e = {};
    function t(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    e.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })();
    var n = "(prefers-reduced-motion: reduce)";
    function i(e) {
      e.length = 0;
    }
    function r(e, t, n) {
      return Array.prototype.slice.call(e, t, n);
    }
    function o(e) {
      return e.bind.apply(e, [null].concat(r(arguments, 1)));
    }
    var s = setTimeout,
      a = function () {};
    function u(e) {
      return requestAnimationFrame(e);
    }
    function c(e, t) {
      return typeof t === e;
    }
    function l(e) {
      return !v(e) && c("object", e);
    }
    var d = Array.isArray,
      f = o(c, "function"),
      h = o(c, "string"),
      p = o(c, "undefined");
    function v(e) {
      return null === e;
    }
    function m(e) {
      try {
        return e instanceof (e.ownerDocument.defaultView || window).HTMLElement;
      } catch (e) {
        return !1;
      }
    }
    function y(e) {
      return d(e) ? e : [e];
    }
    function g(e, t) {
      y(e).forEach(t);
    }
    function b(e, t) {
      return e.indexOf(t) > -1;
    }
    function w(e, t) {
      return e.push.apply(e, y(t)), e;
    }
    function E(e, t, n) {
      e &&
        g(t, function (t) {
          t && e.classList[n ? "add" : "remove"](t);
        });
    }
    function _(e, t) {
      E(e, h(t) ? t.split(" ") : t, !0);
    }
    function k(e, t) {
      g(t, e.appendChild.bind(e));
    }
    function P(e, t) {
      g(e, function (e) {
        var n = (t || e).parentNode;
        n && n.insertBefore(e, t);
      });
    }
    function S(e, t) {
      return m(e) && (e.msMatchesSelector || e.matches).call(e, t);
    }
    function C(e, t) {
      var n = e ? r(e.children) : [];
      return t
        ? n.filter(function (e) {
            return S(e, t);
          })
        : n;
    }
    function x(e, t) {
      return t ? C(e, t)[0] : e.firstElementChild;
    }
    var A = Object.keys;
    function T(e, t, n) {
      return (
        e &&
          (n ? A(e).reverse() : A(e)).forEach(function (n) {
            "__proto__" !== n && t(e[n], n);
          }),
        e
      );
    }
    function M(e) {
      return (
        r(arguments, 1).forEach(function (t) {
          T(t, function (n, i) {
            e[i] = t[i];
          });
        }),
        e
      );
    }
    function L(e) {
      return (
        r(arguments, 1).forEach(function (t) {
          T(t, function (t, n) {
            d(t)
              ? (e[n] = t.slice())
              : l(t)
                ? (e[n] = L({}, l(e[n]) ? e[n] : {}, t))
                : (e[n] = t);
          });
        }),
        e
      );
    }
    function N(e, t) {
      g(t || A(e), function (t) {
        delete e[t];
      });
    }
    function F(e, t) {
      g(e, function (e) {
        g(t, function (t) {
          e && e.removeAttribute(t);
        });
      });
    }
    function j(e, t, n) {
      l(t)
        ? T(t, function (t, n) {
            j(e, n, t);
          })
        : g(e, function (e) {
            v(n) || "" === n ? F(e, t) : e.setAttribute(t, String(n));
          });
    }
    function I(e, t, n) {
      var i = document.createElement(e);
      return t && (h(t) ? _(i, t) : j(i, t)), n && k(n, i), i;
    }
    function O(e, t, n) {
      if (p(n)) return getComputedStyle(e)[t];
      v(n) || (e.style[t] = "" + n);
    }
    function R(e, t) {
      O(e, "display", t);
    }
    function D(e) {
      (e.setActive && e.setActive()) || e.focus({ preventScroll: !0 });
    }
    function V(e, t) {
      return e.getAttribute(t);
    }
    function z(e, t) {
      return e && e.classList.contains(t);
    }
    function q(e) {
      return e.getBoundingClientRect();
    }
    function W(e) {
      g(e, function (e) {
        e && e.parentNode && e.parentNode.removeChild(e);
      });
    }
    function $(e) {
      return x(new DOMParser().parseFromString(e, "text/html").body);
    }
    function B(e, t) {
      e.preventDefault(),
        t && (e.stopPropagation(), e.stopImmediatePropagation());
    }
    function Y(e, t) {
      return e && e.querySelector(t);
    }
    function H(e, t) {
      return t ? r(e.querySelectorAll(t)) : [];
    }
    function U(e, t) {
      E(e, t, !1);
    }
    function X(e) {
      return e.timeStamp;
    }
    function G(e) {
      return h(e) ? e : e ? e + "px" : "";
    }
    var Q = "splide";
    function J(e, t) {
      if (!e) throw new Error("[splide] " + (t || ""));
    }
    var K = Math.min,
      Z = Math.max,
      ee = Math.floor,
      te = Math.ceil,
      ne = Math.abs;
    function ie(e, t, n) {
      return ne(e - t) < n;
    }
    function re(e, t, n, i) {
      var r = K(t, n),
        o = Z(t, n);
      return i ? r < e && e < o : r <= e && e <= o;
    }
    function oe(e, t, n) {
      var i = K(t, n),
        r = Z(t, n);
      return K(Z(i, e), r);
    }
    function se(e) {
      return +(e > 0) - +(e < 0);
    }
    function ae(e, t) {
      return (
        g(t, function (t) {
          e = e.replace("%s", "" + t);
        }),
        e
      );
    }
    function ue(e) {
      return e < 10 ? "0" + e : "" + e;
    }
    var ce = {};
    function le() {
      var e = [];
      function t(e, t, n) {
        g(e, function (e) {
          e &&
            g(t, function (t) {
              t.split(" ").forEach(function (t) {
                var i = t.split(".");
                n(e, i[0], i[1]);
              });
            });
        });
      }
      return {
        bind: function (n, i, r, o) {
          t(n, i, function (t, n, i) {
            var s = "addEventListener" in t,
              a = s
                ? t.removeEventListener.bind(t, n, r, o)
                : t.removeListener.bind(t, r);
            s ? t.addEventListener(n, r, o) : t.addListener(r),
              e.push([t, n, i, r, a]);
          });
        },
        unbind: function (n, i, r) {
          t(n, i, function (t, n, i) {
            e = e.filter(function (e) {
              return (
                !!(e[0] !== t || e[1] !== n || e[2] !== i || (r && e[3] !== r)) ||
                (e[4](), !1)
              );
            });
          });
        },
        dispatch: function (e, t, n) {
          var i;
          return (
            "function" == typeof CustomEvent
              ? (i = new CustomEvent(t, { bubbles: !0, detail: n }))
              : (i = document.createEvent("CustomEvent")).initCustomEvent(
                  t,
                  !0,
                  !1,
                  n,
                ),
            e.dispatchEvent(i),
            i
          );
        },
        destroy: function () {
          e.forEach(function (e) {
            e[4]();
          }),
            i(e);
        },
      };
    }
    var de = "mounted",
      fe = "ready",
      he = "move",
      pe = "moved",
      ve = "click",
      me = "refresh",
      ye = "updated",
      ge = "resize",
      be = "resized",
      we = "scroll",
      Ee = "scrolled",
      _e = "destroy",
      ke = "navigation:mounted",
      Pe = "autoplay:play",
      Se = "autoplay:pause",
      Ce = "lazyload:loaded",
      xe = "ei";
    function Ae(e) {
      var t = e ? e.event.bus : document.createDocumentFragment(),
        n = le();
      return (
        e && e.event.on(_e, n.destroy),
        M(n, {
          bus: t,
          on: function (e, i) {
            n.bind(t, y(e).join(" "), function (e) {
              i.apply(i, d(e.detail) ? e.detail : []);
            });
          },
          off: o(n.unbind, t),
          emit: function (e) {
            n.dispatch(t, e, r(arguments, 1));
          },
        })
      );
    }
    function Te(e, t, n, i) {
      var r,
        o,
        s = Date.now,
        a = 0,
        c = !0,
        l = 0;
      function d() {
        if (!c) {
          if (
            ((a = e ? K((s() - r) / e, 1) : 1),
            n && n(a),
            a >= 1 && (t(), (r = s()), i && ++l >= i))
          )
            return f();
          o = u(d);
        }
      }
      function f() {
        c = !0;
      }
      function h() {
        o && cancelAnimationFrame(o), (a = 0), (o = 0), (c = !0);
      }
      return {
        start: function (t) {
          t || h(), (r = s() - (t ? a * e : 0)), (c = !1), (o = u(d));
        },
        rewind: function () {
          (r = s()), (a = 0), n && n(a);
        },
        pause: f,
        cancel: h,
        set: function (t) {
          e = t;
        },
        isPaused: function () {
          return c;
        },
      };
    }
    var Me = "ArrowLeft",
      Le = "ArrowRight",
      Ne = "ArrowUp",
      Fe = "ArrowDown",
      je = "ttb",
      Ie = {
        width: ["height"],
        left: ["top", "right"],
        right: ["bottom", "left"],
        x: ["y"],
        X: ["Y"],
        Y: ["X"],
        ArrowLeft: [Ne, Le],
        ArrowRight: [Fe, Me],
      };
    var Oe = "role",
      Re = "tabindex",
      De = "aria-controls",
      Ve = "aria-current",
      ze = "aria-selected",
      qe = "aria-label",
      We = "aria-labelledby",
      $e = "aria-hidden",
      Be = "aria-orientation",
      Ye = "aria-roledescription",
      He = "aria-live",
      Ue = "aria-busy",
      Xe = "aria-atomic",
      Ge = [Oe, Re, "disabled", De, Ve, qe, We, $e, Be, Ye],
      Qe = Q,
      Je = "splide__track",
      Ke = "splide__slide",
      Ze = Ke + "--clone",
      et = "splide__arrows",
      tt = "splide__arrow",
      nt = tt + "--prev",
      it = tt + "--next",
      rt = "splide__pagination",
      ot = "is-active",
      st = "is-prev",
      at = "is-next",
      ut = "is-visible",
      ct = "is-loading",
      lt = "is-focus-in",
      dt = "is-overflow",
      ft = [ot, ut, st, at, ct, lt, dt],
      ht = {
        slide: Ke,
        clone: Ze,
        arrows: et,
        arrow: tt,
        prev: nt,
        next: it,
        pagination: rt,
        page: "splide__pagination__page",
        spinner: "splide__spinner",
      },
      pt = "touchmove mousemove",
      vt = "touchend touchcancel mouseup click",
      mt = "slide",
      yt = "loop",
      gt = "fade";
    var bt = { passive: !1, capture: !0 },
      wt = { Spacebar: " ", Right: Le, Left: Me, Up: Ne, Down: Fe };
    function Et(e) {
      return (e = h(e) ? e : e.key), wt[e] || e;
    }
    var _t = "keydown",
      kt = "data-splide-lazy",
      Pt = "data-splide-lazy-srcset",
      St = [" ", "Enter"],
      Ct = Object.freeze({
        __proto__: null,
        Media: function (e, t, i) {
          var r = e.state,
            o = i.breakpoints || {},
            s = i.reducedMotion || {},
            a = le(),
            u = [];
          function c(e) {
            e && a.destroy();
          }
          function l(e, t) {
            var n = matchMedia(t);
            a.bind(n, "change", d), u.push([e, n]);
          }
          function d() {
            var t = r.is(7),
              n = i.direction,
              o = u.reduce(function (e, t) {
                return L(e, t[1].matches ? t[0] : {});
              }, {});
            N(i),
              f(o),
              i.destroy
                ? e.destroy("completely" === i.destroy)
                : t
                  ? (c(!0), e.mount())
                  : n !== i.direction && e.refresh();
          }
          function f(t, n, o) {
            L(i, t),
              n && L(Object.getPrototypeOf(i), t),
              (!o && r.is(1)) || e.emit(ye, i);
          }
          return {
            setup: function () {
              var e = "min" === i.mediaQuery;
              A(o)
                .sort(function (t, n) {
                  return e ? +t - +n : +n - +t;
                })
                .forEach(function (t) {
                  l(o[t], "(" + (e ? "min" : "max") + "-width:" + t + "px)");
                }),
                l(s, n),
                d();
            },
            destroy: c,
            reduce: function (e) {
              matchMedia(n).matches && (e ? L(i, s) : N(i, A(s)));
            },
            set: f,
          };
        },
        Direction: function (e, t, n) {
          return {
            resolve: function (e, t, i) {
              var r =
                "rtl" !== (i = i || n.direction) || t ? (i === je ? 0 : -1) : 1;
              return (
                (Ie[e] && Ie[e][r]) ||
                e.replace(/width|left|right/i, function (e, t) {
                  var n = Ie[e.toLowerCase()][r] || e;
                  return t > 0 ? n.charAt(0).toUpperCase() + n.slice(1) : n;
                })
              );
            },
            orient: function (e) {
              return e * ("rtl" === n.direction ? 1 : -1);
            },
          };
        },
        Elements: function (e, t, n) {
          var r,
            o,
            s,
            a = Ae(e),
            u = a.on,
            c = a.bind,
            l = e.root,
            d = n.i18n,
            h = {},
            p = [],
            v = [],
            m = [];
          function y() {
            var e, t, i;
            (r = k("." + Je)),
              (o = x(r, ".splide__list")),
              J(r && o, "A track/list element is missing."),
              w(p, C(o, ".splide__slide:not(." + Ze + ")")),
              T(
                {
                  arrows: et,
                  pagination: rt,
                  prev: nt,
                  next: it,
                  bar: "splide__progress__bar",
                  toggle: "splide__toggle",
                },
                function (e, t) {
                  h[t] = k("." + e);
                },
              ),
              M(h, { root: l, track: r, list: o, slides: p }),
              (t = l.id || "" + (e = Q) + ue((ce[e] = (ce[e] || 0) + 1))),
              (i = n.role),
              (l.id = t),
              (r.id = r.id || t + "-track"),
              (o.id = o.id || t + "-list"),
              !V(l, Oe) && "SECTION" !== l.tagName && i && j(l, Oe, i),
              j(l, Ye, d.carousel),
              j(o, Oe, "presentation"),
              b();
          }
          function g(e) {
            var t = Ge.concat("style");
            i(p), U(l, v), U(r, m), F([r, o], t), F(l, e ? t : ["style", Ye]);
          }
          function b() {
            U(l, v),
              U(r, m),
              (v = P(Qe)),
              (m = P(Je)),
              _(l, v),
              _(r, m),
              j(l, qe, n.label),
              j(l, We, n.labelledby);
          }
          function k(e) {
            var t = Y(l, e);
            return t &&
              (function (e, t) {
                if (f(e.closest)) return e.closest(t);
                for (var n = e; n && 1 === n.nodeType && !S(n, t); )
                  n = n.parentElement;
                return n;
              })(t, ".splide") === l
              ? t
              : void 0;
          }
          function P(e) {
            return [
              e + "--" + n.type,
              e + "--" + n.direction,
              n.drag && e + "--draggable",
              n.isNavigation && e + "--nav",
              e === Qe && ot,
            ];
          }
          return M(h, {
            setup: y,
            mount: function () {
              u(me, g),
                u(me, y),
                u(ye, b),
                c(
                  document,
                  "touchstart mousedown keydown",
                  function (e) {
                    s = "keydown" === e.type;
                  },
                  { capture: !0 },
                ),
                c(l, "focusin", function () {
                  E(l, lt, !!s);
                });
            },
            destroy: g,
          });
        },
        Slides: function (e, t, n) {
          var r = Ae(e),
            s = r.on,
            a = r.emit,
            u = r.bind,
            c = t.Elements,
            l = c.slides,
            d = c.list,
            p = [];
          function v() {
            l.forEach(function (e, t) {
              C(e, t, -1);
            });
          }
          function w() {
            T(function (e) {
              e.destroy();
            }),
              i(p);
          }
          function C(t, n, i) {
            var r = (function (e, t, n, i) {
              var r,
                s = Ae(e),
                a = s.on,
                u = s.emit,
                c = s.bind,
                l = e.Components,
                d = e.root,
                f = e.options,
                h = f.isNavigation,
                p = f.updateOnMove,
                v = f.i18n,
                m = f.pagination,
                y = f.slideFocus,
                g = l.Direction.resolve,
                b = V(i, "style"),
                w = V(i, qe),
                _ = n > -1,
                k = x(i, ".splide__slide__container");
              function P() {
                var r = e.splides
                  .map(function (e) {
                    var n = e.splide.Components.Slides.getAt(t);
                    return n ? n.slide.id : "";
                  })
                  .join(" ");
                j(i, qe, ae(v.slideX, (_ ? n : t) + 1)),
                  j(i, De, r),
                  j(i, Oe, y ? "button" : ""),
                  y && F(i, Ye);
              }
              function S() {
                r || C();
              }
              function C() {
                if (!r) {
                  var n = e.index;
                  (o = A()) !== z(i, ot) &&
                    (E(i, ot, o),
                    j(i, Ve, (h && o) || ""),
                    u(o ? "active" : "inactive", T)),
                    (function () {
                      var t = (function () {
                          if (e.is(gt)) return A();
                          var t = q(l.Elements.track),
                            n = q(i),
                            r = g("left", !0),
                            o = g("right", !0);
                          return ee(t[r]) <= te(n[r]) && ee(n[o]) <= te(t[o]);
                        })(),
                        n = !t && (!A() || _);
                      if (
                        (e.state.is([4, 5]) || j(i, $e, n || ""),
                        j(H(i, f.focusableNodes || ""), Re, n ? -1 : ""),
                        y && j(i, Re, n ? -1 : 0),
                        t !== z(i, ut) &&
                          (E(i, ut, t), u(t ? "visible" : "hidden", T)),
                        !t && document.activeElement === i)
                      ) {
                        var r = l.Slides.getAt(e.index);
                        r && D(r.slide);
                      }
                    })(),
                    E(i, st, t === n - 1),
                    E(i, at, t === n + 1);
                }
                var o;
              }
              function A() {
                var i = e.index;
                return i === t || (f.cloneStatus && i === n);
              }
              var T = {
                index: t,
                slideIndex: n,
                slide: i,
                container: k,
                isClone: _,
                mount: function () {
                  _ ||
                    ((i.id = d.id + "-slide" + ue(t + 1)),
                    j(i, Oe, m ? "tabpanel" : "group"),
                    j(i, Ye, v.slide),
                    j(i, qe, w || ae(v.slideLabel, [t + 1, e.length]))),
                    c(i, "click", o(u, ve, T)),
                    c(i, "keydown", o(u, "sk", T)),
                    a([pe, "sh", Ee], C),
                    a(ke, P),
                    p && a(he, S);
                },
                destroy: function () {
                  (r = !0),
                    s.destroy(),
                    U(i, ft),
                    F(i, Ge),
                    j(i, "style", b),
                    j(i, qe, w || "");
                },
                update: C,
                style: function (e, t, n) {
                  O((n && k) || i, e, t);
                },
                isWithin: function (n, i) {
                  var r = ne(n - t);
                  return (
                    _ || (!f.rewind && !e.is(yt)) || (r = K(r, e.length - r)),
                    r <= i
                  );
                },
              };
              return T;
            })(e, n, i, t);
            r.mount(),
              p.push(r),
              p.sort(function (e, t) {
                return e.index - t.index;
              });
          }
          function A(e) {
            return e
              ? M(function (e) {
                  return !e.isClone;
                })
              : p;
          }
          function T(e, t) {
            A(t).forEach(e);
          }
          function M(e) {
            return p.filter(
              f(e)
                ? e
                : function (t) {
                    return h(e) ? S(t.slide, e) : b(y(e), t.index);
                  },
            );
          }
          return {
            mount: function () {
              v(), s(me, w), s(me, v);
            },
            destroy: w,
            update: function () {
              T(function (e) {
                e.update();
              });
            },
            register: C,
            get: A,
            getIn: function (e) {
              var i = t.Controller,
                r = i.toIndex(e),
                o = i.hasFocus() ? 1 : n.perPage;
              return M(function (e) {
                return re(e.index, r, r + o - 1);
              });
            },
            getAt: function (e) {
              return M(e)[0];
            },
            add: function (e, t) {
              g(e, function (e) {
                if ((h(e) && (e = $(e)), m(e))) {
                  var i = l[t];
                  i ? P(e, i) : k(d, e),
                    _(e, n.classes.slide),
                    (r = e),
                    (s = o(a, ge)),
                    (c = H(r, "img")),
                    (f = c.length)
                      ? c.forEach(function (e) {
                          u(e, "load error", function () {
                            --f || s();
                          });
                        })
                      : s();
                }
                var r, s, c, f;
              }),
                a(me);
            },
            remove: function (e) {
              W(
                M(e).map(function (e) {
                  return e.slide;
                }),
              ),
                a(me);
            },
            forEach: T,
            filter: M,
            style: function (e, t, n) {
              T(function (i) {
                i.style(e, t, n);
              });
            },
            getLength: function (e) {
              return e ? l.length : p.length;
            },
            isEnough: function () {
              return p.length > n.perPage;
            },
          };
        },
        Layout: function (e, t, n) {
          var i,
            r,
            s,
            a = Ae(e),
            u = a.on,
            c = a.bind,
            d = a.emit,
            f = t.Slides,
            h = t.Direction.resolve,
            p = t.Elements,
            v = p.root,
            m = p.track,
            y = p.list,
            g = f.getAt,
            b = f.style;
          function w() {
            (i = n.direction === je),
              O(v, "maxWidth", G(n.width)),
              O(m, h("paddingLeft"), k(!1)),
              O(m, h("paddingRight"), k(!0)),
              _(!0);
          }
          function _(e) {
            var t,
              o = q(v);
            (e || r.width !== o.width || r.height !== o.height) &&
              (O(
                m,
                "height",
                ((t = ""),
                i &&
                  (J((t = P()), "height or heightRatio is missing."),
                  (t = "calc(" + t + " - " + k(!1) + " - " + k(!0) + ")")),
                t),
              ),
              b(h("marginRight"), G(n.gap)),
              b("width", n.autoWidth ? null : G(n.fixedWidth) || (i ? "" : S())),
              b(
                "height",
                G(n.fixedHeight) || (i ? (n.autoHeight ? null : S()) : P()),
                !0,
              ),
              (r = o),
              d(be),
              s !== (s = L()) && (E(v, dt, s), d("overflow", s)));
          }
          function k(e) {
            var t = n.padding,
              i = h(e ? "right" : "left");
            return (t && G(t[i] || (l(t) ? 0 : t))) || "0px";
          }
          function P() {
            return G(n.height || q(y).width * n.heightRatio);
          }
          function S() {
            var e = G(n.gap);
            return (
              "calc((100%" +
              (e && " + " + e) +
              ")/" +
              (n.perPage || 1) +
              (e && " - " + e) +
              ")"
            );
          }
          function C() {
            return q(y)[h("width")];
          }
          function x(e, t) {
            var n = g(e || 0);
            return n ? q(n.slide)[h("width")] + (t ? 0 : M()) : 0;
          }
          function A(e, t) {
            var n = g(e);
            if (n) {
              var i = q(n.slide)[h("right")],
                r = q(y)[h("left")];
              return ne(i - r) + (t ? 0 : M());
            }
            return 0;
          }
          function T(t) {
            return A(e.length - 1) - A(0) + x(0, t);
          }
          function M() {
            var e = g(0);
            return (e && parseFloat(O(e.slide, h("marginRight")))) || 0;
          }
          function L() {
            return e.is(gt) || T(!0) > C();
          }
          return {
            mount: function () {
              var e, t;
              w(),
                c(
                  window,
                  "resize load",
                  ((e = o(d, ge)),
                  (t = Te(0, e, null, 1)),
                  function () {
                    t.isPaused() && t.start();
                  }),
                ),
                u([ye, me], w),
                u(ge, _);
            },
            resize: _,
            listSize: C,
            slideSize: x,
            sliderSize: T,
            totalSize: A,
            getPadding: function (e) {
              return parseFloat(O(m, h("padding" + (e ? "Right" : "Left")))) || 0;
            },
            isOverflow: L,
          };
        },
        Clones: function (e, t, n) {
          var r,
            o = Ae(e),
            s = o.on,
            a = t.Elements,
            u = t.Slides,
            c = t.Direction.resolve,
            l = [];
          function d() {
            s(me, f),
              s([ye, ge], v),
              (r = m()) &&
                ((function (t) {
                  var i = u.get().slice(),
                    r = i.length;
                  if (r) {
                    for (; i.length < t; ) w(i, i);
                    w(i.slice(-t), i.slice(0, t)).forEach(function (o, s) {
                      var c = s < t,
                        d = (function (t, i) {
                          var r = t.cloneNode(!0);
                          return (
                            _(r, n.classes.clone),
                            (r.id = e.root.id + "-clone" + ue(i + 1)),
                            r
                          );
                        })(o.slide, s);
                      c ? P(d, i[0].slide) : k(a.list, d),
                        w(l, d),
                        u.register(d, s - t + (c ? 0 : r), o.index);
                    });
                  }
                })(r),
                t.Layout.resize(!0));
          }
          function f() {
            h(), d();
          }
          function h() {
            W(l), i(l), o.destroy();
          }
          function v() {
            var e = m();
            r !== e && (r < e || !e) && o.emit(me);
          }
          function m() {
            var i = n.clones;
            if (e.is(yt)) {
              if (p(i)) {
                var r = n[c("fixedWidth")] && t.Layout.slideSize(0);
                i =
                  (r && te(q(a.track)[c("width")] / r)) ||
                  (n[c("autoWidth")] && e.length) ||
                  2 * n.perPage;
              }
            } else i = 0;
            return i;
          }
          return { mount: d, destroy: h };
        },
        Move: function (e, t, n) {
          var i,
            r = Ae(e),
            o = r.on,
            s = r.emit,
            a = e.state.set,
            u = t.Layout,
            c = u.slideSize,
            l = u.getPadding,
            d = u.totalSize,
            f = u.listSize,
            h = u.sliderSize,
            v = t.Direction,
            m = v.resolve,
            y = v.orient,
            g = t.Elements,
            b = g.list,
            w = g.track;
          function E() {
            t.Controller.isBusy() ||
              (t.Scroll.cancel(), _(e.index), t.Slides.update());
          }
          function _(e) {
            k(x(e, !0));
          }
          function k(n, i) {
            if (!e.is(gt)) {
              var r = i
                ? n
                : (function (n) {
                    if (e.is(yt)) {
                      var i = C(n),
                        r = i > t.Controller.getEnd();
                      (i < 0 || r) && (n = P(n, r));
                    }
                    return n;
                  })(n);
              O(b, "transform", "translate" + m("X") + "(" + r + "px)"),
                n !== r && s("sh");
            }
          }
          function P(e, t) {
            var n = e - T(t),
              i = h();
            return e - y(i * (te(ne(n) / i) || 1)) * (t ? 1 : -1);
          }
          function S() {
            k(A(), !0), i.cancel();
          }
          function C(e) {
            for (
              var n = t.Slides.get(), i = 0, r = 1 / 0, o = 0;
              o < n.length;
              o++
            ) {
              var s = n[o].index,
                a = ne(x(s, !0) - e);
              if (!(a <= r)) break;
              (r = a), (i = s);
            }
            return i;
          }
          function x(t, i) {
            var r = y(
              d(t - 1) -
                (function (e) {
                  var t = n.focus;
                  return "center" === t ? (f() - c(e, !0)) / 2 : +t * c(e) || 0;
                })(t),
            );
            return i
              ? (function (t) {
                  return (
                    n.trimSpace && e.is(mt) && (t = oe(t, 0, y(h(!0) - f()))), t
                  );
                })(r)
              : r;
          }
          function A() {
            var e = m("left");
            return q(b)[e] - q(w)[e] + y(l(!1));
          }
          function T(e) {
            return x(e ? t.Controller.getEnd() : 0, !!n.trimSpace);
          }
          return {
            mount: function () {
              (i = t.Transition), o([de, be, ye, me], E);
            },
            move: function (e, t, n, r) {
              var o, u;
              e !== t &&
                ((o = e > n),
                (u = y(P(A(), o))),
                o ? u >= 0 : u <= b[m("scrollWidth")] - q(w)[m("width")]) &&
                (S(), k(P(A(), e > n), !0)),
                a(4),
                s(he, t, n, e),
                i.start(t, function () {
                  a(3), s(pe, t, n, e), r && r();
                });
            },
            jump: _,
            translate: k,
            shift: P,
            cancel: S,
            toIndex: C,
            toPosition: x,
            getPosition: A,
            getLimit: T,
            exceededLimit: function (e, t) {
              t = p(t) ? A() : t;
              var n = !0 !== e && y(t) < y(T(!1)),
                i = !1 !== e && y(t) > y(T(!0));
              return n || i;
            },
            reposition: E,
          };
        },
        Controller: function (e, t, n) {
          var i,
            r,
            s,
            a,
            u = Ae(e),
            c = u.on,
            l = u.emit,
            d = t.Move,
            f = d.getPosition,
            v = d.getLimit,
            m = d.toPosition,
            y = t.Slides,
            g = y.isEnough,
            b = y.getLength,
            w = n.omitEnd,
            E = e.is(yt),
            _ = e.is(mt),
            k = o(T, !1),
            P = o(T, !0),
            S = n.start || 0,
            C = S;
          function x() {
            (r = b(!0)), (s = n.perMove), (a = n.perPage), (i = N());
            var e = oe(S, 0, w ? i : r - 1);
            e !== S && ((S = e), d.reposition());
          }
          function A() {
            i !== N() && l(xe);
          }
          function T(e, t) {
            var n = s || (O() ? 1 : a),
              r = M(S + n * (e ? -1 : 1), S, !(s || O()));
            return -1 === r && _ && !ie(f(), v(!e), 1)
              ? e
                ? 0
                : i
              : t
                ? r
                : L(r);
          }
          function M(t, o, u) {
            if (g() || O()) {
              var c = (function (t) {
                if (_ && "move" === n.trimSpace && t !== S)
                  for (
                    var i = f();
                    i === m(t, !0) && re(t, 0, e.length - 1, !n.rewind);
  
                  )
                    t < S ? --t : ++t;
                return t;
              })(t);
              c !== t && ((o = t), (t = c), (u = !1)),
                t < 0 || t > i
                  ? (t =
                      s || (!re(0, t, o, !0) && !re(i, o, t, !0))
                        ? E
                          ? u
                            ? t < 0
                              ? -(r % a || a)
                              : r
                            : t
                          : n.rewind
                            ? t < 0
                              ? i
                              : 0
                            : -1
                        : F(j(t)))
                  : u && t !== o && (t = F(j(o) + (t < o ? -1 : 1)));
            } else t = -1;
            return t;
          }
          function L(e) {
            return E ? (e + r) % r || 0 : e;
          }
          function N() {
            for (var e = r - (O() || (E && s) ? 1 : a); w && e-- > 0; )
              if (m(r - 1, !0) !== m(e, !0)) {
                e++;
                break;
              }
            return oe(e, 0, r - 1);
          }
          function F(e) {
            return oe(O() ? e : a * e, 0, i);
          }
          function j(e) {
            return O() ? K(e, i) : ee((e >= i ? r - 1 : e) / a);
          }
          function I(e) {
            e !== S && ((C = S), (S = e));
          }
          function O() {
            return !p(n.focus) || n.isNavigation;
          }
          function R() {
            return e.state.is([4, 5]) && !!n.waitForTransition;
          }
          return {
            mount: function () {
              x(), c([ye, me, xe], x), c(be, A);
            },
            go: function (e, t, n) {
              if (!R()) {
                var r = (function (e) {
                    var t = S;
                    if (h(e)) {
                      var n = e.match(/([+\-<>])(\d+)?/) || [],
                        r = n[1],
                        o = n[2];
                      "+" === r || "-" === r
                        ? (t = M(S + +("" + r + (+o || 1)), S))
                        : ">" === r
                          ? (t = o ? F(+o) : k(!0))
                          : "<" === r && (t = P(!0));
                    } else t = E ? e : oe(e, 0, i);
                    return t;
                  })(e),
                  o = L(r);
                o > -1 && (t || o !== S) && (I(o), d.move(r, o, C, n));
              }
            },
            scroll: function (e, n, r, o) {
              t.Scroll.scroll(e, n, r, function () {
                var e = L(d.toIndex(f()));
                I(w ? K(e, i) : e), o && o();
              });
            },
            getNext: k,
            getPrev: P,
            getAdjacent: T,
            getEnd: N,
            setIndex: I,
            getIndex: function (e) {
              return e ? C : S;
            },
            toIndex: F,
            toPage: j,
            toDest: function (e) {
              var t = d.toIndex(e);
              return _ ? oe(t, 0, i) : t;
            },
            hasFocus: O,
            isBusy: R,
          };
        },
        Arrows: function (e, t, n) {
          var i,
            r,
            s = Ae(e),
            a = s.on,
            u = s.bind,
            c = s.emit,
            l = n.classes,
            d = n.i18n,
            f = t.Elements,
            h = t.Controller,
            p = f.arrows,
            v = f.track,
            m = p,
            y = f.prev,
            g = f.next,
            b = {};
          function w() {
            var e;
            !(e = n.arrows) ||
              (y && g) ||
              ((m = p || I("div", l.arrows)),
              (y = x(!0)),
              (g = x(!1)),
              (i = !0),
              k(m, [y, g]),
              !p && P(m, v)),
              y &&
                g &&
                (M(b, { prev: y, next: g }),
                R(m, e ? "" : "none"),
                _(m, (r = et + "--" + n.direction)),
                e &&
                  (a([de, pe, me, Ee, xe], A),
                  u(g, "click", o(C, ">")),
                  u(y, "click", o(C, "<")),
                  A(),
                  j([y, g], De, v.id),
                  c("arrows:mounted", y, g))),
              a(ye, E);
          }
          function E() {
            S(), w();
          }
          function S() {
            s.destroy(),
              U(m, r),
              i ? (W(p ? [y, g] : m), (y = g = null)) : F([y, g], Ge);
          }
          function C(e) {
            h.go(e, !0);
          }
          function x(e) {
            return $(
              '<button class="' +
                l.arrow +
                " " +
                (e ? l.prev : l.next) +
                '" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="' +
                (n.arrowPath ||
                  "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z") +
                '" />',
            );
          }
          function A() {
            if (y && g) {
              var t = e.index,
                n = h.getPrev(),
                i = h.getNext(),
                r = n > -1 && t < n ? d.last : d.prev,
                o = i > -1 && t > i ? d.first : d.next;
              (y.disabled = n < 0),
                (g.disabled = i < 0),
                j(y, qe, r),
                j(g, qe, o),
                c("arrows:updated", y, g, n, i);
            }
          }
          return { arrows: b, mount: w, destroy: S, update: A };
        },
        Autoplay: function (e, t, n) {
          var i,
            r,
            o = Ae(e),
            s = o.on,
            a = o.bind,
            u = o.emit,
            c = Te(n.interval, e.go.bind(e, ">"), function (e) {
              var t = d.bar;
              t && O(t, "width", 100 * e + "%"), u("autoplay:playing", e);
            }),
            l = c.isPaused,
            d = t.Elements,
            f = t.Elements,
            h = f.root,
            p = f.toggle,
            v = n.autoplay,
            m = "pause" === v;
          function y() {
            l() &&
              t.Slides.isEnough() &&
              (c.start(!n.resetProgress), (r = i = m = !1), w(), u(Pe));
          }
          function g(e) {
            void 0 === e && (e = !0), (m = !!e), w(), l() || (c.pause(), u(Se));
          }
          function b() {
            m || (i || r ? g(!1) : y());
          }
          function w() {
            p && (E(p, ot, !m), j(p, qe, n.i18n[m ? "play" : "pause"]));
          }
          function _(e) {
            var i = t.Slides.getAt(e);
            c.set((i && +V(i.slide, "data-splide-interval")) || n.interval);
          }
          return {
            mount: function () {
              v &&
                (n.pauseOnHover &&
                  a(h, "mouseenter mouseleave", function (e) {
                    (i = "mouseenter" === e.type), b();
                  }),
                n.pauseOnFocus &&
                  a(h, "focusin focusout", function (e) {
                    (r = "focusin" === e.type), b();
                  }),
                p &&
                  a(p, "click", function () {
                    m ? y() : g(!0);
                  }),
                s([he, we, me], c.rewind),
                s(he, _),
                p && j(p, De, d.track.id),
                m || y(),
                w());
            },
            destroy: c.cancel,
            play: y,
            pause: g,
            isPaused: l,
          };
        },
        Cover: function (e, t, n) {
          var i = Ae(e).on;
          function r(e) {
            t.Slides.forEach(function (t) {
              var n = x(t.container || t.slide, "img");
              n && n.src && s(e, n, t);
            });
          }
          function s(e, t, n) {
            n.style(
              "background",
              e ? 'center/cover no-repeat url("' + t.src + '")' : "",
              !0,
            ),
              R(t, e ? "none" : "");
          }
          return {
            mount: function () {
              n.cover && (i(Ce, o(s, !0)), i([de, ye, me], o(r, !0)));
            },
            destroy: o(r, !1),
          };
        },
        Scroll: function (e, t, n) {
          var i,
            r,
            s = Ae(e),
            a = s.on,
            u = s.emit,
            c = e.state.set,
            l = t.Move,
            d = l.getPosition,
            f = l.getLimit,
            h = l.exceededLimit,
            p = l.translate,
            v = e.is(mt),
            m = 1;
          function y(e, n, s, a, f) {
            var p = d();
            if ((w(), s && (!v || !h()))) {
              var y = t.Layout.sliderSize(),
                E = se(e) * y * ee(ne(e) / y) || 0;
              e = l.toPosition(t.Controller.toDest(e % y)) + E;
            }
            var _ = ie(p, e, 1);
            (m = 1),
              (n = _ ? 0 : n || Z(ne(e - p) / 1.5, 800)),
              (r = a),
              (i = Te(n, g, o(b, p, e, f), 1)),
              c(5),
              u(we),
              i.start();
          }
          function g() {
            c(3), r && r(), u(Ee);
          }
          function b(e, t, i, o) {
            var s,
              a,
              u = d(),
              c =
                (e +
                  (t - e) *
                    ((s = o),
                    (a = n.easingFunc) ? a(s) : 1 - Math.pow(1 - s, 4)) -
                  u) *
                m;
            p(u + c),
              v &&
                !i &&
                h() &&
                ((m *= 0.6), ne(c) < 10 && y(f(h(!0)), 600, !1, r, !0));
          }
          function w() {
            i && i.cancel();
          }
          function E() {
            i && !i.isPaused() && (w(), g());
          }
          return {
            mount: function () {
              a(he, w), a([ye, me], E);
            },
            destroy: w,
            scroll: y,
            cancel: E,
          };
        },
        Drag: function (e, t, n) {
          var i,
            r,
            o,
            s,
            u,
            c,
            d,
            f,
            h = Ae(e),
            p = h.on,
            v = h.emit,
            m = h.bind,
            y = h.unbind,
            g = e.state,
            b = t.Move,
            w = t.Scroll,
            E = t.Controller,
            _ = t.Elements.track,
            k = t.Media.reduce,
            P = t.Direction,
            C = P.resolve,
            x = P.orient,
            A = b.getPosition,
            T = b.exceededLimit,
            M = !1;
          function L() {
            var e = n.drag;
            W(!e), (s = "free" === e);
          }
          function N(e) {
            if (((c = !1), !d)) {
              var t = q(e);
              (i = e.target),
                (r = n.noDrag),
                S(i, ".splide__pagination__page, ." + tt) ||
                  (r && S(i, r)) ||
                  (!t && e.button) ||
                  (E.isBusy()
                    ? B(e, !0)
                    : ((f = t ? _ : window),
                      (u = g.is([4, 5])),
                      (o = null),
                      m(f, pt, F, bt),
                      m(f, vt, j, bt),
                      b.cancel(),
                      w.cancel(),
                      O(e)));
            }
            var i, r;
          }
          function F(t) {
            if ((g.is(6) || (g.set(6), v("drag")), t.cancelable))
              if (u) {
                b.translate(i + R(t) / (M && e.is(mt) ? 5 : 1));
                var r = D(t) > 200,
                  o = M !== (M = T());
                (r || o) && O(t), (c = !0), v("dragging"), B(t);
              } else
                (function (e) {
                  return ne(R(e)) > ne(R(e, !0));
                })(t) &&
                  ((u = (function (e) {
                    var t = n.dragMinThreshold,
                      i = l(t),
                      r = (i && t.mouse) || 0,
                      o = (i ? t.touch : +t) || 10;
                    return ne(R(e)) > (q(e) ? o : r);
                  })(t)),
                  B(t));
          }
          function j(i) {
            g.is(6) && (g.set(3), v("dragged")),
              u &&
                ((function (i) {
                  var r = (function (t) {
                      if (e.is(yt) || !M) {
                        var n = D(t);
                        if (n && n < 200) return R(t) / n;
                      }
                      return 0;
                    })(i),
                    o = (function (e) {
                      return (
                        A() +
                        se(e) *
                          K(
                            ne(e) * (n.flickPower || 600),
                            s
                              ? 1 / 0
                              : t.Layout.listSize() * (n.flickMaxPages || 1),
                          )
                      );
                    })(r),
                    a = n.rewind && n.rewindByDrag;
                  k(!1),
                    s
                      ? E.scroll(o, 0, n.snap)
                      : e.is(gt)
                        ? E.go(x(se(r)) < 0 ? (a ? "<" : "-") : a ? ">" : "+")
                        : e.is(mt) && M && a
                          ? E.go(T(!0) ? ">" : "<")
                          : E.go(E.toDest(o), !0),
                    k(!0);
                })(i),
                B(i)),
              y(f, pt, F),
              y(f, vt, j),
              (u = !1);
          }
          function I(e) {
            !d && c && B(e, !0);
          }
          function O(e) {
            (o = r), (r = e), (i = A());
          }
          function R(e, t) {
            return z(e, t) - z(V(e), t);
          }
          function D(e) {
            return X(e) - X(V(e));
          }
          function V(e) {
            return (r === e && o) || r;
          }
          function z(e, t) {
            return (q(e) ? e.changedTouches[0] : e)["page" + C(t ? "Y" : "X")];
          }
          function q(e) {
            return "undefined" != typeof TouchEvent && e instanceof TouchEvent;
          }
          function W(e) {
            d = e;
          }
          return {
            mount: function () {
              m(_, pt, a, bt),
                m(_, vt, a, bt),
                m(_, "touchstart mousedown", N, bt),
                m(_, "click", I, { capture: !0 }),
                m(_, "dragstart", B),
                p([de, ye], L);
            },
            disable: W,
            isDragging: function () {
              return u;
            },
          };
        },
        Keyboard: function (e, t, n) {
          var i,
            r,
            o = Ae(e),
            a = o.on,
            u = o.bind,
            c = o.unbind,
            l = e.root,
            d = t.Direction.resolve;
          function f() {
            var e = n.keyboard;
            e && ((i = "global" === e ? window : l), u(i, _t, v));
          }
          function h() {
            c(i, _t);
          }
          function p() {
            var e = r;
            (r = !0),
              s(function () {
                r = e;
              });
          }
          function v(t) {
            if (!r) {
              var n = Et(t);
              n === d(Me) ? e.go("<") : n === d(Le) && e.go(">");
            }
          }
          return {
            mount: function () {
              f(), a(ye, h), a(ye, f), a(he, p);
            },
            destroy: h,
            disable: function (e) {
              r = e;
            },
          };
        },
        LazyLoad: function (e, t, n) {
          var r = Ae(e),
            s = r.on,
            a = r.off,
            u = r.bind,
            c = r.emit,
            l = "sequential" === n.lazyLoad,
            d = [pe, Ee],
            f = [];
          function h() {
            i(f),
              t.Slides.forEach(function (e) {
                H(
                  e.slide,
                  "[data-splide-lazy], [data-splide-lazy-srcset]",
                ).forEach(function (t) {
                  var i = V(t, kt),
                    r = V(t, Pt);
                  if (i !== t.src || r !== t.srcset) {
                    var o = n.classes.spinner,
                      s = t.parentElement,
                      a = x(s, "." + o) || I("span", o, s);
                    f.push([t, e, a]), t.src || R(t, "none");
                  }
                });
              }),
              l ? y() : (a(d), s(d, p), p());
          }
          function p() {
            (f = f.filter(function (t) {
              var i = n.perPage * ((n.preloadPages || 1) + 1) - 1;
              return !t[1].isWithin(e.index, i) || v(t);
            })).length || a(d);
          }
          function v(e) {
            var t = e[0];
            _(e[1].slide, ct),
              u(t, "load error", o(m, e)),
              j(t, "src", V(t, kt)),
              j(t, "srcset", V(t, Pt)),
              F(t, kt),
              F(t, Pt);
          }
          function m(e, t) {
            var n = e[0],
              i = e[1];
            U(i.slide, ct),
              "error" !== t.type && (W(e[2]), R(n, ""), c(Ce, n, i), c(ge)),
              l && y();
          }
          function y() {
            f.length && v(f.shift());
          }
          return {
            mount: function () {
              n.lazyLoad && (h(), s(me, h));
            },
            destroy: o(i, f),
            check: p,
          };
        },
        Pagination: function (e, t, n) {
          var s,
            a,
            u = Ae(e),
            c = u.on,
            l = u.emit,
            d = u.bind,
            f = t.Slides,
            h = t.Elements,
            p = t.Controller,
            v = p.hasFocus,
            m = p.getIndex,
            y = p.go,
            g = t.Direction.resolve,
            b = h.pagination,
            w = [];
          function E() {
            s && (W(b ? r(s.children) : s), U(s, a), i(w), (s = null)),
              u.destroy();
          }
          function k(e) {
            y(">" + e, !0);
          }
          function P(e, t) {
            var n = w.length,
              i = Et(t),
              r = S(),
              o = -1;
            i === g(Le, !1, r)
              ? (o = ++e % n)
              : i === g(Me, !1, r)
                ? (o = (--e + n) % n)
                : "Home" === i
                  ? (o = 0)
                  : "End" === i && (o = n - 1);
            var s = w[o];
            s && (D(s.button), y(">" + o), B(t, !0));
          }
          function S() {
            return n.paginationDirection || n.direction;
          }
          function C(e) {
            return w[p.toPage(e)];
          }
          function x() {
            var e = C(m(!0)),
              t = C(m());
            if (e) {
              var n = e.button;
              U(n, ot), F(n, ze), j(n, Re, -1);
            }
            if (t) {
              var i = t.button;
              _(i, ot), j(i, ze, !0), j(i, Re, "");
            }
            l("pagination:updated", { list: s, items: w }, e, t);
          }
          return {
            items: w,
            mount: function t() {
              E(), c([ye, me, xe], t);
              var i = n.pagination;
              b && R(b, i ? "" : "none"),
                i &&
                  (c([he, we, Ee], x),
                  (function () {
                    var t = e.length,
                      i = n.classes,
                      r = n.i18n,
                      u = n.perPage,
                      c = v() ? p.getEnd() + 1 : te(t / u);
                    _(
                      (s = b || I("ul", i.pagination, h.track.parentElement)),
                      (a = rt + "--" + S()),
                    ),
                      j(s, Oe, "tablist"),
                      j(s, qe, r.select),
                      j(s, Be, S() === je ? "vertical" : "");
                    for (var l = 0; l < c; l++) {
                      var m = I("li", null, s),
                        y = I("button", { class: i.page, type: "button" }, m),
                        g = f.getIn(l).map(function (e) {
                          return e.slide.id;
                        }),
                        E = !v() && u > 1 ? r.pageX : r.slideX;
                      d(y, "click", o(k, l)),
                        n.paginationKeyboard && d(y, "keydown", o(P, l)),
                        j(m, Oe, "presentation"),
                        j(y, Oe, "tab"),
                        j(y, De, g.join(" ")),
                        j(y, qe, ae(E, l + 1)),
                        j(y, Re, -1),
                        w.push({ li: m, button: y, page: l });
                    }
                  })(),
                  x(),
                  l("pagination:mounted", { list: s, items: w }, C(e.index)));
            },
            destroy: E,
            getAt: C,
            update: x,
          };
        },
        Sync: function (e, t, n) {
          var r = n.isNavigation,
            s = n.slideFocus,
            a = [];
          function u() {
            var t, n;
            e.splides.forEach(function (t) {
              t.isParent || (l(e, t.splide), l(t.splide, e));
            }),
              r &&
                ((n = (t = Ae(e)).on)(ve, f),
                n("sk", h),
                n([de, ye], d),
                a.push(t),
                t.emit(ke, e.splides));
          }
          function c() {
            a.forEach(function (e) {
              e.destroy();
            }),
              i(a);
          }
          function l(e, t) {
            var n = Ae(e);
            n.on(he, function (e, n, i) {
              t.go(t.is(yt) ? i : e);
            }),
              a.push(n);
          }
          function d() {
            j(t.Elements.list, Be, n.direction === je ? "vertical" : "");
          }
          function f(t) {
            e.go(t.index);
          }
          function h(e, t) {
            b(St, Et(t)) && (f(e), B(t));
          }
          return {
            setup: o(t.Media.set, { slideFocus: p(s) ? r : s }, !0),
            mount: u,
            destroy: c,
            remount: function () {
              c(), u();
            },
          };
        },
        Wheel: function (e, t, n) {
          var i = Ae(e).bind,
            r = 0;
          function o(i) {
            if (i.cancelable) {
              var o = i.deltaY,
                s = o < 0,
                a = X(i),
                u = n.wheelMinThreshold || 0,
                c = n.wheelSleep || 0;
              ne(o) > u && a - r > c && (e.go(s ? "<" : ">"), (r = a)),
                (function (i) {
                  return (
                    !n.releaseWheel ||
                    e.state.is(4) ||
                    -1 !== t.Controller.getAdjacent(i)
                  );
                })(s) && B(i);
            }
          }
          return {
            mount: function () {
              n.wheel && i(t.Elements.track, "wheel", o, bt);
            },
          };
        },
        Live: function (e, t, n) {
          var i = Ae(e).on,
            r = t.Elements.track,
            s = n.live && !n.isNavigation,
            a = I("span", "splide__sr"),
            u = Te(90, o(c, !1));
          function c(e) {
            j(r, Ue, e), e ? (k(r, a), u.start()) : (W(a), u.cancel());
          }
          function l(e) {
            s && j(r, He, e ? "off" : "polite");
          }
          return {
            mount: function () {
              s &&
                (l(!t.Autoplay.isPaused()),
                j(r, Xe, !0),
                (a.textContent = "…"),
                i(Pe, o(l, !0)),
                i(Se, o(l, !1)),
                i([pe, Ee], o(c, !0)));
            },
            disable: l,
            destroy: function () {
              F(r, [He, Xe, Ue]), W(a);
            },
          };
        },
      }),
      xt = {
        type: "slide",
        role: "region",
        speed: 400,
        perPage: 1,
        cloneStatus: !0,
        arrows: !0,
        pagination: !0,
        paginationKeyboard: !0,
        interval: 5e3,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        resetProgress: !0,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        drag: !0,
        direction: "ltr",
        trimSpace: !0,
        focusableNodes: "a, button, textarea, input, select, iframe",
        live: !0,
        classes: ht,
        i18n: {
          prev: "Previous slide",
          next: "Next slide",
          first: "Go to first slide",
          last: "Go to last slide",
          slideX: "Go to slide %s",
          pageX: "Go to page %s",
          play: "Start autoplay",
          pause: "Pause autoplay",
          carousel: "carousel",
          slide: "slide",
          select: "Select a slide to show",
          slideLabel: "%s of %s",
        },
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: "pause" },
      };
    function At(e, t, n) {
      var i = t.Slides;
      function r() {
        i.forEach(function (e) {
          e.style("transform", "translateX(-" + 100 * e.index + "%)");
        });
      }
      return {
        mount: function () {
          Ae(e).on([de, me], r);
        },
        start: function (e, t) {
          i.style("transition", "opacity " + n.speed + "ms " + n.easing), s(t);
        },
        cancel: a,
      };
    }
    function Tt(e, t, n) {
      var i,
        r = t.Move,
        s = t.Controller,
        a = t.Scroll,
        u = t.Elements.list,
        c = o(O, u, "transition");
      function l() {
        c(""), a.cancel();
      }
      return {
        mount: function () {
          Ae(e).bind(u, "transitionend", function (e) {
            e.target === u && i && (l(), i());
          });
        },
        start: function (t, o) {
          var u = r.toPosition(t, !0),
            l = r.getPosition(),
            d = (function (t) {
              var i = n.rewindSpeed;
              if (e.is(mt) && i) {
                var r = s.getIndex(!0),
                  o = s.getEnd();
                if ((0 === r && t >= o) || (r >= o && 0 === t)) return i;
              }
              return n.speed;
            })(t);
          ne(u - l) >= 1 && d >= 1
            ? n.useScroll
              ? a.scroll(u, d, !1, o)
              : (c("transform " + d + "ms " + n.easing),
                r.translate(u, !0),
                (i = o))
            : (r.jump(t), o());
        },
        cancel: l,
      };
    }
    var Mt = (function () {
      function e(t, n) {
        var i;
        (this.event = Ae()),
          (this.Components = {}),
          (this.state =
            ((i = 1),
            {
              set: function (e) {
                i = e;
              },
              is: function (e) {
                return b(y(e), i);
              },
            })),
          (this.splides = []),
          (this._o = {}),
          (this._E = {});
        var r = h(t) ? Y(document, t) : t;
        J(r, r + " is invalid."),
          (this.root = r),
          (n = L(
            { label: V(r, qe) || "", labelledby: V(r, We) || "" },
            xt,
            e.defaults,
            n || {},
          ));
        try {
          L(n, JSON.parse(V(r, "data-splide")));
        } catch (e) {
          J(!1, "Invalid JSON");
        }
        this._o = Object.create(L({}, n));
      }
      var n,
        o,
        s = e.prototype;
      return (
        (s.mount = function (e, t) {
          var n = this,
            i = this.state,
            r = this.Components;
          return (
            J(i.is([1, 7]), "Already mounted!"),
            i.set(1),
            (this._C = r),
            (this._T = t || this._T || (this.is(gt) ? At : Tt)),
            (this._E = e || this._E),
            T(M({}, Ct, this._E, { Transition: this._T }), function (e, t) {
              var i = e(n, r, n._o);
              (r[t] = i), i.setup && i.setup();
            }),
            T(r, function (e) {
              e.mount && e.mount();
            }),
            this.emit(de),
            _(this.root, "is-initialized"),
            i.set(3),
            this.emit(fe),
            this
          );
        }),
        (s.sync = function (e) {
          return (
            this.splides.push({ splide: e }),
            e.splides.push({ splide: this, isParent: !0 }),
            this.state.is(3) &&
              (this._C.Sync.remount(), e.Components.Sync.remount()),
            this
          );
        }),
        (s.go = function (e) {
          return this._C.Controller.go(e), this;
        }),
        (s.on = function (e, t) {
          return this.event.on(e, t), this;
        }),
        (s.off = function (e) {
          return this.event.off(e), this;
        }),
        (s.emit = function (e) {
          var t;
          return (
            (t = this.event).emit.apply(t, [e].concat(r(arguments, 1))), this
          );
        }),
        (s.add = function (e, t) {
          return this._C.Slides.add(e, t), this;
        }),
        (s.remove = function (e) {
          return this._C.Slides.remove(e), this;
        }),
        (s.is = function (e) {
          return this._o.type === e;
        }),
        (s.refresh = function () {
          return this.emit(me), this;
        }),
        (s.destroy = function (e) {
          void 0 === e && (e = !0);
          var t = this.event,
            n = this.state;
          return (
            n.is(1)
              ? Ae(this).on(fe, this.destroy.bind(this, e))
              : (T(
                  this._C,
                  function (t) {
                    t.destroy && t.destroy(e);
                  },
                  !0,
                ),
                t.emit(_e),
                t.destroy(),
                e && i(this.splides),
                n.set(7)),
            this
          );
        }),
        (n = e),
        (o = [
          {
            key: "options",
            get: function () {
              return this._o;
            },
            set: function (e) {
              this._C.Media.set(e, !0, !0);
            },
          },
          {
            key: "length",
            get: function () {
              return this._C.Slides.getLength(!0);
            },
          },
          {
            key: "index",
            get: function () {
              return this._C.Controller.getIndex();
            },
          },
        ]) && t(n.prototype, o),
        Object.defineProperty(n, "prototype", { writable: !1 }),
        e
      );
    })();
    function Lt(e, t, n) {
      return Array.prototype.slice.call(e, t, n);
    }
    function Nt(e) {
      return e.bind.apply(e, [null].concat(Lt(arguments, 1)));
    }
    function Ft(e, t) {
      return typeof t === e;
    }
    (Mt.defaults = {}),
      (Mt.STATES = {
        CREATED: 1,
        MOUNTED: 2,
        IDLE: 3,
        MOVING: 4,
        SCROLLING: 5,
        DRAGGING: 6,
        DESTROYED: 7,
      });
    var jt = Array.isArray;
    function It(e) {
      return jt(e) ? e : [e];
    }
    function Ot(e, t) {
      It(e).forEach(t);
    }
    Nt(Ft, "function"), Nt(Ft, "string"), Nt(Ft, "undefined");
    var Rt = Object.keys;
    function Dt(e, t, n) {
      if (e) {
        var i = Rt(e);
        i = n ? i.reverse() : i;
        for (var r = 0; r < i.length; r++) {
          var o = i[r];
          if ("__proto__" !== o && !1 === t(e[o], o)) break;
        }
      }
      return e;
    }
    var Vt = "refresh";
    function zt(e) {
      var t = e ? e.event.bus : document.createDocumentFragment(),
        n = (function () {
          var e = [];
          function t(e, t, n) {
            Ot(e, function (e) {
              e &&
                Ot(t, function (t) {
                  t.split(" ").forEach(function (t) {
                    var i = t.split(".");
                    n(e, i[0], i[1]);
                  });
                });
            });
          }
          return {
            bind: function (n, i, r, o) {
              t(n, i, function (t, n, i) {
                var s = "addEventListener" in t,
                  a = s
                    ? t.removeEventListener.bind(t, n, r, o)
                    : t.removeListener.bind(t, r);
                s ? t.addEventListener(n, r, o) : t.addListener(r),
                  e.push([t, n, i, r, a]);
              });
            },
            unbind: function (n, i, r) {
              t(n, i, function (t, n, i) {
                e = e.filter(function (e) {
                  return (
                    !!(
                      e[0] !== t ||
                      e[1] !== n ||
                      e[2] !== i ||
                      (r && e[3] !== r)
                    ) || (e[4](), !1)
                  );
                });
              });
            },
            dispatch: function (e, t, n) {
              var i;
              return (
                "function" == typeof CustomEvent
                  ? (i = new CustomEvent(t, { bubbles: !0, detail: n }))
                  : (i = document.createEvent("CustomEvent")).initCustomEvent(
                      t,
                      !0,
                      !1,
                      n,
                    ),
                e.dispatchEvent(i),
                i
              );
            },
            destroy: function () {
              e.forEach(function (e) {
                e[4]();
              }),
                (e.length = 0);
            },
          };
        })();
      return (
        e && e.event.on("destroy", n.destroy),
        (function (e) {
          return (
            Lt(arguments, 1).forEach(function (t) {
              Dt(t, function (n, i) {
                e[i] = t[i];
              });
            }),
            e
          );
        })(n, {
          bus: t,
          on: function (e, i) {
            n.bind(t, It(e).join(" "), function (e) {
              i.apply(i, jt(e.detail) ? e.detail : []);
            });
          },
          off: Nt(n.unbind, t),
          emit: function (e) {
            n.dispatch(t, e, Lt(arguments, 1));
          },
        })
      );
    }
    function qt(e) {
      e.length = 0;
    }
    function Wt(e, t, n) {
      return Array.prototype.slice.call(e, t, n);
    }
    function $t(e) {
      return e.bind(null, ...Wt(arguments, 1));
    }
    function Bt(e, t) {
      return typeof t === e;
    }
    const Yt = Array.isArray;
    $t(Bt, "function");
    const Ht = $t(Bt, "string"),
      Ut = $t(Bt, "undefined");
    function Xt(e) {
      return null === e;
    }
    function Gt(e) {
      return Yt(e) ? e : [e];
    }
    function Qt(e, t) {
      Gt(e).forEach(t);
    }
    function Jt(e, t) {
      return e.push(...Gt(t)), e;
    }
    function Kt(e, t, n) {
      e &&
        Qt(t, (t) => {
          t && e.classList[n ? "add" : "remove"](t);
        });
    }
    function Zt(e, t) {
      Kt(e, Ht(t) ? t.split(" ") : t, !0);
    }
    function en(e, t) {
      Qt(t, e.appendChild.bind(e));
    }
    function tn(e, t) {
      return t
        ? (function (e, t) {
            const n = e ? Wt(e.children) : [];
            return t
              ? n.filter((e) =>
                  (function (e, t) {
                    return (
                      e instanceof HTMLElement &&
                      (e.msMatchesSelector || e.matches).call(e, t)
                    );
                  })(e, t),
                )
              : n;
          })(e, t)[0]
        : e.firstElementChild;
    }
    const nn = Object.keys;
    function rn(e, t, n) {
      if (e) {
        let i = nn(e);
        i = n ? i.reverse() : i;
        for (let n = 0; n < i.length; n++) {
          const r = i[n];
          if ("__proto__" !== r && !1 === t(e[r], r)) break;
        }
      }
      return e;
    }
    function on(e, t) {
      Qt(e, (e) => {
        Qt(t, (t) => {
          e && e.removeAttribute(t);
        });
      });
    }
    function sn(e, t, n) {
      var i;
      !Xt((i = t)) && Bt("object", i)
        ? rn(t, (t, n) => {
            sn(e, n, t);
          })
        : Qt(e, (e) => {
            Xt(n) || "" === n ? on(e, t) : e.setAttribute(t, String(n));
          });
    }
    function an(e, t, n) {
      const i = document.createElement(e);
      return t && (Ht(t) ? Zt(i, t) : sn(i, t)), n && en(n, i), i;
    }
    function un(e, t, n) {
      if (Ut(n)) return getComputedStyle(e)[t];
      Xt(n) || (e.style[t] = `${n}`);
    }
    function cn(e, t) {
      return t ? Wt(e.querySelectorAll(t)) : [];
    }
    function ln(e, t) {
      Kt(e, t, !1);
    }
    function dn(e) {
      return Ht(e) ? e : e ? `${e}px` : "";
    }
    const { min: fn, max: hn, floor: pn, ceil: vn, abs: mn } = Math,
      yn = "splide__slide--col",
      gn = { rows: 1, cols: 1, dimensions: [], gap: {} };
    function bn(e, t, n) {
      const { on: i, off: r } = zt(e),
        { Elements: o } = t,
        s = {},
        a = (function (e) {
          function t() {
            const { rows: t, cols: n, dimensions: i } = e;
            return Yt(i) && i.length ? i : [[t, n]];
          }
          return {
            get: function (e) {
              const n = t();
              return n[fn(e, n.length - 1)];
            },
            getAt: function (e) {
              const n = t();
              let i,
                r,
                o = 0;
              for (let t = 0; t < n.length; t++) {
                const s = n[t];
                if (((i = s[0] || 1), (r = s[1] || 1), (o += i * r), e < o))
                  break;
              }
              return (
                (function (e, t) {
                  if (!e) throw new Error("[splide] Invalid dimension");
                })(i && r),
                [i, r]
              );
            },
          };
        })(s),
        u = (function (e, t, n) {
          const { on: i, destroy: r } = zt(e),
            { Components: o, options: s } = e,
            { resolve: a } = o.Direction,
            { forEach: u } = o.Slides;
          function c(e, t) {
            const n = tn(e, ".splide__slide__container"),
              i = tn(n || e, "img");
            i &&
              i.src &&
              (un(
                n || e,
                "background",
                t ? "" : `center/cover no-repeat url("${i.src}")`,
              ),
              un(i, "display", t ? "" : "none"));
          }
          function l(e) {
            return cn(e, ".splide__slide__row");
          }
          function d(e) {
            return cn(e, ".splide__slide--col");
          }
          function f(e, t) {
            d(e).forEach((e) => {
              sn(e, "tabindex", t ? 0 : null);
            });
          }
          function h(e) {
            f(e.slide, !0);
          }
          function p(e) {
            f(e.slide, !1);
          }
          return {
            mount: function () {
              u((i) => {
                const { slide: r } = i,
                  [o, s] = n.get(i.isClone ? i.slideIndex : i.index);
                !(function (e, n) {
                  const { row: i } = t.gap,
                    r = `calc(${100 / e}%${i ? ` - ${dn(i)} * ${(e - 1) / e}` : ""})`;
                  l(n).forEach((e, t, n) => {
                    un(e, "height", r),
                      un(e, "display", "flex"),
                      un(e, "margin", `0 0 ${dn(i)} 0`),
                      un(e, "padding", 0),
                      t === n.length - 1 && un(e, "marginBottom", 0);
                  });
                })(o, r),
                  (function (e, n) {
                    const { col: i } = t.gap,
                      r = `calc(${100 / e}%${i ? ` - ${dn(i)} * ${(e - 1) / e}` : ""})`;
                    d(n).forEach((e, t, n) => {
                      un(e, "width", r),
                        t !== n.length - 1 && un(e, a("marginRight"), dn(i));
                    });
                  })(s, r),
                  d(i.slide).forEach((t, n) => {
                    var r;
                    (t.id = `${i.slide.id}-col${((r = n + 1), r < 10 ? `0${r}` : `${r}`)}`),
                      e.options.cover && c(t);
                  });
              }),
                s.slideFocus && (i("visible", h), i("hidden", p));
            },
            destroy: function () {
              u((e) => {
                const { slide: t } = e;
                f(t, !1),
                  l(t).forEach((e) => {
                    on(e, "style");
                  }),
                  d(t).forEach((e) => {
                    c(e, !0), on(e, "style");
                  });
              }),
                r();
            },
          };
        })(e, s, a),
        c = "splide--grid",
        l = [];
      function d() {
        var t;
        Gt(nn((t = s))).forEach((e) => {
          delete t[e];
        }),
          (function (e) {
            Wt(arguments, 1).forEach((t) => {
              rn(t, (n, i) => {
                e[i] = t[i];
              });
            });
          })(s, gn, n.grid || {}),
          (function () {
            if (n.grid) {
              const { rows: e, cols: t, dimensions: n } = s;
              return e > 1 || t > 1 || (Yt(n) && n.length > 0);
            }
            return !1;
          })()
            ? (f(),
              Jt(l, o.slides),
              Zt(e.root, c),
              en(
                o.list,
                (function () {
                  const e = [];
                  let t,
                    n,
                    i = 0,
                    r = 0;
                  return (
                    l.forEach((o, s) => {
                      const [u, c] = a.getAt(s);
                      r ||
                        (i || ((t = an(o.tagName, "splide__slide")), e.push(t)),
                        (n = (function (e, t, n) {
                          return an(
                            "li" === t.tagName.toLowerCase() ? "ul" : "div",
                            "splide__slide__row",
                            n,
                          );
                        })(0, o, t))),
                        (function (e, t, n) {
                          Zt(t, yn), en(n, t);
                        })(0, o, n),
                        ++r >= c && ((r = 0), (i = ++i >= u ? 0 : i));
                    }),
                    e
                  );
                })(),
              ),
              r(Vt),
              i(Vt, p),
              h())
            : v() && (f(), h());
      }
      function f() {
        if (v()) {
          const { slides: t } = o;
          u.destroy(),
            l.forEach((e) => {
              ln(e, yn), en(o.list, e);
            }),
            Qt(t, (e) => {
              e && e.parentNode && e.parentNode.removeChild(e);
            }),
            ln(e.root, c),
            qt(t),
            Jt(t, l),
            qt(l),
            r(Vt);
        }
      }
      function h() {
        e.refresh();
      }
      function p() {
        v() && u.mount();
      }
      function v() {
        return (t = e.root), c, t && t.classList.contains("splide--grid");
        var t;
      }
      return {
        mount: function () {
          d(), i("updated", d);
        },
        destroy: f,
      };
    }
    function wn(e, t, n) {
      return Array.prototype.slice.call(e, t, n);
    }
    function En(e) {
      return e.bind.apply(e, [null].concat(wn(arguments, 1)));
    }
    function _n(e, t) {
      return typeof t === e;
    }
    var kn = Array.isArray;
    function Pn(e) {
      return kn(e) ? e : [e];
    }
    function Sn(e, t) {
      Pn(e).forEach(t);
    }
    En(_n, "function"), En(_n, "string"), En(_n, "undefined");
    var Cn = Object.keys;
    function xn(e, t, n) {
      if (e) {
        var i = Cn(e);
        i = n ? i.reverse() : i;
        for (var r = 0; r < i.length; r++) {
          var o = i[r];
          if ("__proto__" !== o && !1 === t(e[o], o)) break;
        }
      }
      return e;
    }
    var An = "dragging";
    function Tn(e) {
      var t = e ? e.event.bus : document.createDocumentFragment(),
        n = (function () {
          var e = [];
          function t(e, t, n) {
            Sn(e, function (e) {
              e &&
                Sn(t, function (t) {
                  t.split(" ").forEach(function (t) {
                    var i = t.split(".");
                    n(e, i[0], i[1]);
                  });
                });
            });
          }
          return {
            bind: function (n, i, r, o) {
              t(n, i, function (t, n, i) {
                var s = "addEventListener" in t,
                  a = s
                    ? t.removeEventListener.bind(t, n, r, o)
                    : t.removeListener.bind(t, r);
                s ? t.addEventListener(n, r, o) : t.addListener(r),
                  e.push([t, n, i, r, a]);
              });
            },
            unbind: function (n, i, r) {
              t(n, i, function (t, n, i) {
                e = e.filter(function (e) {
                  return (
                    !!(
                      e[0] !== t ||
                      e[1] !== n ||
                      e[2] !== i ||
                      (r && e[3] !== r)
                    ) || (e[4](), !1)
                  );
                });
              });
            },
            dispatch: function (e, t, n) {
              var i;
              return (
                "function" == typeof CustomEvent
                  ? (i = new CustomEvent(t, { bubbles: !0, detail: n }))
                  : (i = document.createEvent("CustomEvent")).initCustomEvent(
                      t,
                      !0,
                      !1,
                      n,
                    ),
                e.dispatchEvent(i),
                i
              );
            },
            destroy: function () {
              e.forEach(function (e) {
                e[4]();
              }),
                (e.length = 0);
            },
          };
        })();
      return (
        e && e.event.on("destroy", n.destroy),
        (function (e) {
          return (
            wn(arguments, 1).forEach(function (t) {
              xn(t, function (n, i) {
                e[i] = t[i];
              });
            }),
            e
          );
        })(n, {
          bus: t,
          on: function (e, i) {
            n.bind(t, Pn(e).join(" "), function (e) {
              i.apply(i, kn(e.detail) ? e.detail : []);
            });
          },
          off: En(n.unbind, t),
          emit: function (e) {
            n.dispatch(t, e, wn(arguments, 1));
          },
        })
      );
    }
    function Mn(e, t, n) {
      return Array.prototype.slice.call(e, t, n);
    }
    function Ln(e) {
      return e.bind(null, ...Mn(arguments, 1));
    }
    function Nn(e, t) {
      return typeof t === e;
    }
    function Fn(e) {
      return !Dn(e) && Nn("object", e);
    }
    const jn = Array.isArray,
      In = Ln(Nn, "function"),
      On = Ln(Nn, "string"),
      Rn = Ln(Nn, "undefined");
    function Dn(e) {
      return null === e;
    }
    function Vn(e, t) {
      var n;
      ((n = e), jn(n) ? n : [n]).forEach(t);
    }
    function zn(e, t, n) {
      e &&
        Vn(t, (t) => {
          t && e.classList[n ? "add" : "remove"](t);
        });
    }
    function qn(e, t) {
      zn(e, On(t) ? t.split(" ") : t, !0);
    }
    function Wn(e, t) {
      return t
        ? (function (e, t) {
            const n = e ? Mn(e.children) : [];
            return t
              ? n.filter((e) =>
                  (function (e, t) {
                    return (
                      e instanceof HTMLElement &&
                      (e.msMatchesSelector || e.matches).call(e, t)
                    );
                  })(e, t),
                )
              : n;
          })(e, t)[0]
        : e.firstElementChild;
    }
    const $n = Object.keys;
    function Bn(e, t, n) {
      if (e) {
        let i = $n(e);
        i = n ? i.reverse() : i;
        for (let n = 0; n < i.length; n++) {
          const r = i[n];
          if ("__proto__" !== r && !1 === t(e[r], r)) break;
        }
      }
      return e;
    }
    function Yn(e) {
      return (
        Mn(arguments, 1).forEach((t) => {
          Bn(t, (n, i) => {
            e[i] = t[i];
          });
        }),
        e
      );
    }
    function Hn(e) {
      return (
        Mn(arguments, 1).forEach((t) => {
          Bn(t, (t, n) => {
            jn(t)
              ? (e[n] = t.slice())
              : Fn(t)
                ? (e[n] = Hn({}, Fn(e[n]) ? e[n] : {}, t))
                : (e[n] = t);
          });
        }),
        e
      );
    }
    function Un(e, t, n) {
      Fn(t)
        ? Bn(t, (t, n) => {
            Un(e, n, t);
          })
        : Vn(e, (e) => {
            Dn(n) || "" === n
              ? (function (e, t) {
                  Vn(e, (e) => {
                    Vn(t, (t) => {
                      e && e.removeAttribute(t);
                    });
                  });
                })(e, t)
              : e.setAttribute(t, String(n));
          });
    }
    function Xn(e, t, n) {
      const i = document.createElement(e);
      return (
        t && (On(t) ? qn(i, t) : Un(i, t)),
        n &&
          (function (e, t) {
            Vn(t, e.appendChild.bind(e));
          })(n, i),
        i
      );
    }
    function Gn(e, t) {
      !(function (e, t, n) {
        if (Rn(n)) return getComputedStyle(e)[t];
        Dn(n) || (e.style[t] = `${n}`);
      })(e, "display", t);
    }
    function Qn(e, t) {
      zn(e, t, !1);
    }
    const { min: Jn, max: Kn, floor: Zn, ceil: ei, abs: ti } = Math;
    function ni(e, t, n) {
      const i = Jn(t, n),
        r = Kn(t, n);
      return Jn(Kn(i, e), r);
    }
    const ii = { hideControls: !1, loop: !1, mute: !1, volume: 0.2 },
      ri = "video:click";
    class oi {
      constructor(e, t, n) {
        var i;
        (this.state =
          ((i = 1),
          {
            set: function (e) {
              i = e;
            },
            is: function (e) {
              return (t = Pn(e)), (n = i), t.indexOf(n) > -1;
              var t, n;
            },
          })),
          (this.event = Tn()),
          (this.target = e),
          (this.videoId = t),
          (this.options = n || {}),
          (this.onPlay = this.onPlay.bind(this)),
          (this.onPause = this.onPause.bind(this)),
          (this.onEnded = this.onEnded.bind(this)),
          (this.onPlayerReady = this.onPlayerReady.bind(this)),
          (this.onError = this.onError.bind(this));
      }
      on(e, t) {
        this.event.on(e, t);
      }
      play() {
        const { state: e } = this;
        return e.is(9)
          ? ("Can not play this video.",
            void console.error("[splide] Can not play this video."))
          : (this.event.emit("play"),
            e.is(2)
              ? e.set(4)
              : e.is(3)
                ? ((this.player = this.createPlayer(this.videoId)), e.set(4))
                : void (
                    e.is([4, 8]) ||
                    (e.is(5) && (e.set(6), this.playVideo()))
                  ));
      }
      pause() {
        const { state: e } = this;
        if (!e.is(9))
          return (
            this.event.emit("pause"),
            e.is(4)
              ? e.set(2)
              : e.is(6)
                ? e.set(7)
                : void (e.is(8) && (this.pauseVideo(), this.state.set(5)))
          );
      }
      isPaused() {
        return !this.state.is(8);
      }
      destroy() {
        this.event.destroy();
      }
      onPlayerReady() {
        const { state: e } = this,
          t = e.is(4);
        e.set(5), t && this.play();
      }
      onPlay() {
        const { state: e } = this,
          t = e.is(7);
        e.set(8), t ? this.pause() : this.event.emit("played");
      }
      onPause() {
        this.state.set(5), this.event.emit("paused");
      }
      onEnded() {
        this.state.set(5), this.event.emit("ended");
      }
      onError() {
        this.state.set(9), this.event.emit("error");
      }
    }
    function si(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function ai(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var ui = void 0 !== e.g && "[object global]" === {}.toString.call(e.g);
    function ci(e, t) {
      return 0 === e.indexOf(t.toLowerCase())
        ? e
        : ""
            .concat(t.toLowerCase())
            .concat(e.substr(0, 1).toUpperCase())
            .concat(e.substr(1));
    }
    function li(e) {
      return Boolean(
        e &&
          1 === e.nodeType &&
          "nodeName" in e &&
          e.ownerDocument &&
          e.ownerDocument.defaultView,
      );
    }
    function di(e) {
      return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
    }
    function fi(e) {
      return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(e);
    }
    function hi(e) {
      return /^https:\/\/player\.vimeo\.com\/video\/\d+/.test(e);
    }
    function pi() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.id,
        n = e.url,
        i = t || n;
      if (!i)
        throw new Error(
          "An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.",
        );
      if (di(i)) return "https://vimeo.com/".concat(i);
      if (fi(i)) return i.replace("http:", "https:");
      if (t) throw new TypeError("“".concat(t, "” is not a valid video id."));
      throw new TypeError("“".concat(i, "” is not a vimeo.com url."));
    }
    var vi = void 0 !== Array.prototype.indexOf,
      mi = "undefined" != typeof window && void 0 !== window.postMessage;
    if (!(ui || (vi && mi)))
      throw new Error(
        "Sorry, the Vimeo Player API is not available in this browser.",
      );
    var yi =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof window
          ? window
          : void 0 !== e.g
            ? e.g
            : "undefined" != typeof self
              ? self
              : {};
    !(function (e) {
      if (!e.WeakMap) {
        var t = Object.prototype.hasOwnProperty,
          n =
            Object.defineProperty &&
            (function () {
              try {
                return 1 === Object.defineProperty({}, "x", { value: 1 }).x;
              } catch (e) {}
            })(),
          i = function (e, t, i) {
            n
              ? Object.defineProperty(e, t, {
                  configurable: !0,
                  writable: !0,
                  value: i,
                })
              : (e[t] = i);
          };
        e.WeakMap = (function () {
          function e() {
            if (void 0 === this)
              throw new TypeError("Constructor WeakMap requires 'new'");
            if ((i(this, "_id", o("_WeakMap")), arguments.length > 0))
              throw new TypeError("WeakMap iterable is not supported");
          }
          function n(e, n) {
            if (!r(e) || !t.call(e, "_id"))
              throw new TypeError(
                n + " method called on incompatible receiver " + typeof e,
              );
          }
          function o(e) {
            return e + "_" + s() + "." + s();
          }
          function s() {
            return Math.random().toString().substring(2);
          }
          return (
            i(e.prototype, "delete", function (e) {
              if ((n(this, "delete"), !r(e))) return !1;
              var t = e[this._id];
              return !(!t || t[0] !== e || (delete e[this._id], 0));
            }),
            i(e.prototype, "get", function (e) {
              if ((n(this, "get"), r(e))) {
                var t = e[this._id];
                return t && t[0] === e ? t[1] : void 0;
              }
            }),
            i(e.prototype, "has", function (e) {
              if ((n(this, "has"), !r(e))) return !1;
              var t = e[this._id];
              return !(!t || t[0] !== e);
            }),
            i(e.prototype, "set", function (e, t) {
              if ((n(this, "set"), !r(e)))
                throw new TypeError("Invalid value used as weak map key");
              var o = e[this._id];
              return o && o[0] === e
                ? ((o[1] = t), this)
                : (i(e, this._id, [e, t]), this);
            }),
            i(e, "_polyfill", !0),
            e
          );
        })();
      }
      function r(e) {
        return Object(e) === e;
      }
    })(
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof self
          ? self
          : "undefined" != typeof window
            ? window
            : yi,
    );
    var gi,
      bi,
      wi =
        ((gi = function (e) {
          var t, n, i;
          (i = function () {
            var e,
              t,
              n,
              i = Object.prototype.toString,
              r =
                "undefined" != typeof setImmediate
                  ? function (e) {
                      return setImmediate(e);
                    }
                  : setTimeout;
            try {
              Object.defineProperty({}, "x", {}),
                (e = function (e, t, n, i) {
                  return Object.defineProperty(e, t, {
                    value: n,
                    writable: !0,
                    configurable: !1 !== i,
                  });
                });
            } catch (t) {
              e = function (e, t, n) {
                return (e[t] = n), e;
              };
            }
            function o(e, i) {
              n.add(e, i), t || (t = r(n.drain));
            }
            function s(e) {
              var t,
                n = typeof e;
              return (
                null == e || ("object" != n && "function" != n) || (t = e.then),
                "function" == typeof t && t
              );
            }
            function a() {
              for (var e = 0; e < this.chain.length; e++)
                u(
                  this,
                  1 === this.state
                    ? this.chain[e].success
                    : this.chain[e].failure,
                  this.chain[e],
                );
              this.chain.length = 0;
            }
            function u(e, t, n) {
              var i, r;
              try {
                !1 === t
                  ? n.reject(e.msg)
                  : (i = !0 === t ? e.msg : t.call(void 0, e.msg)) === n.promise
                    ? n.reject(TypeError("Promise-chain cycle"))
                    : (r = s(i))
                      ? r.call(i, n.resolve, n.reject)
                      : n.resolve(i);
              } catch (e) {
                n.reject(e);
              }
            }
            function c(e) {
              var t,
                n = this;
              if (!n.triggered) {
                (n.triggered = !0), n.def && (n = n.def);
                try {
                  (t = s(e))
                    ? o(function () {
                        var i = new f(n);
                        try {
                          t.call(
                            e,
                            function () {
                              c.apply(i, arguments);
                            },
                            function () {
                              l.apply(i, arguments);
                            },
                          );
                        } catch (e) {
                          l.call(i, e);
                        }
                      })
                    : ((n.msg = e), (n.state = 1), n.chain.length > 0 && o(a, n));
                } catch (e) {
                  l.call(new f(n), e);
                }
              }
            }
            function l(e) {
              var t = this;
              t.triggered ||
                ((t.triggered = !0),
                t.def && (t = t.def),
                (t.msg = e),
                (t.state = 2),
                t.chain.length > 0 && o(a, t));
            }
            function d(e, t, n, i) {
              for (var r = 0; r < t.length; r++)
                !(function (r) {
                  e.resolve(t[r]).then(function (e) {
                    n(r, e);
                  }, i);
                })(r);
            }
            function f(e) {
              (this.def = e), (this.triggered = !1);
            }
            function h(e) {
              (this.promise = e),
                (this.state = 0),
                (this.triggered = !1),
                (this.chain = []),
                (this.msg = void 0);
            }
            function p(e) {
              if ("function" != typeof e) throw TypeError("Not a function");
              if (0 !== this.__NPO__) throw TypeError("Not a promise");
              this.__NPO__ = 1;
              var t = new h(this);
              (this.then = function (e, n) {
                var i = {
                  success: "function" != typeof e || e,
                  failure: "function" == typeof n && n,
                };
                return (
                  (i.promise = new this.constructor(function (e, t) {
                    if ("function" != typeof e || "function" != typeof t)
                      throw TypeError("Not a function");
                    (i.resolve = e), (i.reject = t);
                  })),
                  t.chain.push(i),
                  0 !== t.state && o(a, t),
                  i.promise
                );
              }),
                (this.catch = function (e) {
                  return this.then(void 0, e);
                });
              try {
                e.call(
                  void 0,
                  function (e) {
                    c.call(t, e);
                  },
                  function (e) {
                    l.call(t, e);
                  },
                );
              } catch (e) {
                l.call(t, e);
              }
            }
            n = (function () {
              var e, n, i;
              function r(e, t) {
                (this.fn = e), (this.self = t), (this.next = void 0);
              }
              return {
                add: function (t, o) {
                  (i = new r(t, o)),
                    n ? (n.next = i) : (e = i),
                    (n = i),
                    (i = void 0);
                },
                drain: function () {
                  var i = e;
                  for (e = n = t = void 0; i; ) i.fn.call(i.self), (i = i.next);
                },
              };
            })();
            var v = e({}, "constructor", p, !1);
            return (
              (p.prototype = v),
              e(v, "__NPO__", 0, !1),
              e(p, "resolve", function (e) {
                return e && "object" == typeof e && 1 === e.__NPO__
                  ? e
                  : new this(function (t, n) {
                      if ("function" != typeof t || "function" != typeof n)
                        throw TypeError("Not a function");
                      t(e);
                    });
              }),
              e(p, "reject", function (e) {
                return new this(function (t, n) {
                  if ("function" != typeof t || "function" != typeof n)
                    throw TypeError("Not a function");
                  n(e);
                });
              }),
              e(p, "all", function (e) {
                var t = this;
                return "[object Array]" != i.call(e)
                  ? t.reject(TypeError("Not an array"))
                  : 0 === e.length
                    ? t.resolve([])
                    : new t(function (n, i) {
                        if ("function" != typeof n || "function" != typeof i)
                          throw TypeError("Not a function");
                        var r = e.length,
                          o = Array(r),
                          s = 0;
                        d(
                          t,
                          e,
                          function (e, t) {
                            (o[e] = t), ++s === r && n(o);
                          },
                          i,
                        );
                      });
              }),
              e(p, "race", function (e) {
                var t = this;
                return "[object Array]" != i.call(e)
                  ? t.reject(TypeError("Not an array"))
                  : new t(function (n, i) {
                      if ("function" != typeof n || "function" != typeof i)
                        throw TypeError("Not a function");
                      d(
                        t,
                        e,
                        function (e, t) {
                          n(t);
                        },
                        i,
                      );
                    });
              }),
              p
            );
          }),
            ((n = yi)[(t = "Promise")] = n[t] || i()),
            e.exports && (e.exports = n[t]);
        }),
        gi((bi = { exports: {} })),
        bi.exports),
      Ei = new WeakMap();
    function _i(e, t, n) {
      var i = Ei.get(e.element) || {};
      t in i || (i[t] = []), i[t].push(n), Ei.set(e.element, i);
    }
    function ki(e, t) {
      return (Ei.get(e.element) || {})[t] || [];
    }
    function Pi(e, t, n) {
      var i = Ei.get(e.element) || {};
      if (!i[t]) return !0;
      if (!n) return (i[t] = []), Ei.set(e.element, i), !0;
      var r = i[t].indexOf(n);
      return (
        -1 !== r && i[t].splice(r, 1),
        Ei.set(e.element, i),
        i[t] && 0 === i[t].length
      );
    }
    function Si(e, t) {
      var n = Ei.get(e);
      Ei.set(t, n), Ei.delete(e);
    }
    function Ci(e) {
      if ("string" == typeof e)
        try {
          e = JSON.parse(e);
        } catch (e) {
          return console.warn(e), {};
        }
      return e;
    }
    function xi(e, t, n) {
      if (e.element.contentWindow && e.element.contentWindow.postMessage) {
        var i = { method: t };
        void 0 !== n && (i.value = n);
        var r = parseFloat(
          navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"),
        );
        r >= 8 && r < 10 && (i = JSON.stringify(i)),
          e.element.contentWindow.postMessage(i, e.origin);
      }
    }
    function Ai(e, t) {
      var n,
        i = [];
      if ((t = Ci(t)).event)
        "error" === t.event &&
          ki(e, t.data.method).forEach(function (n) {
            var i = new Error(t.data.message);
            (i.name = t.data.name), n.reject(i), Pi(e, t.data.method, n);
          }),
          (i = ki(e, "event:".concat(t.event))),
          (n = t.data);
      else if (t.method) {
        var r = (function (e, t) {
          var n = ki(e, t);
          if (n.length < 1) return !1;
          var i = n.shift();
          return Pi(e, t, i), i;
        })(e, t.method);
        r && (i.push(r), (n = t.value));
      }
      i.forEach(function (t) {
        try {
          if ("function" == typeof t) return void t.call(e, n);
          t.resolve(n);
        } catch (e) {}
      });
    }
    var Ti = [
      "autopause",
      "autoplay",
      "background",
      "byline",
      "color",
      "controls",
      "dnt",
      "height",
      "id",
      "interactive_params",
      "keyboard",
      "loop",
      "maxheight",
      "maxwidth",
      "muted",
      "playsinline",
      "portrait",
      "responsive",
      "speed",
      "texttrack",
      "title",
      "transparent",
      "url",
      "width",
    ];
    function Mi(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return Ti.reduce(function (t, n) {
        var i = e.getAttribute("data-vimeo-".concat(n));
        return (i || "" === i) && (t[n] = "" === i ? 1 : i), t;
      }, t);
    }
    function Li(e, t) {
      var n = e.html;
      if (!t) throw new TypeError("An element must be provided");
      if (null !== t.getAttribute("data-vimeo-initialized"))
        return t.querySelector("iframe");
      var i = document.createElement("div");
      return (
        (i.innerHTML = n),
        t.appendChild(i.firstChild),
        t.setAttribute("data-vimeo-initialized", "true"),
        t.querySelector("iframe")
      );
    }
    function Ni(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = arguments.length > 2 ? arguments[2] : void 0;
      return new Promise(function (i, r) {
        if (!fi(e))
          throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
        var o = "https://vimeo.com/api/oembed.json?url=".concat(
          encodeURIComponent(e),
        );
        for (var s in t)
          t.hasOwnProperty(s) &&
            (o += "&".concat(s, "=").concat(encodeURIComponent(t[s])));
        var a =
          "XDomainRequest" in window
            ? new XDomainRequest()
            : new XMLHttpRequest();
        a.open("GET", o, !0),
          (a.onload = function () {
            if (404 !== a.status)
              if (403 !== a.status)
                try {
                  var t = JSON.parse(a.responseText);
                  if (403 === t.domain_status_code)
                    return (
                      Li(t, n),
                      void r(new Error("“".concat(e, "” is not embeddable.")))
                    );
                  i(t);
                } catch (e) {
                  r(e);
                }
              else r(new Error("“".concat(e, "” is not embeddable.")));
            else r(new Error("“".concat(e, "” was not found.")));
          }),
          (a.onerror = function () {
            var e = a.status ? " (".concat(a.status, ")") : "";
            r(
              new Error(
                "There was an error fetching the embed code from Vimeo".concat(
                  e,
                  ".",
                ),
              ),
            );
          }),
          a.send();
      });
    }
    var Fi = new WeakMap(),
      ji = new WeakMap(),
      Ii = {},
      Oi = (function () {
        function e(t) {
          var n = this,
            i =
              arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (
            (si(this, e),
            window.jQuery &&
              t instanceof jQuery &&
              (t.length > 1 &&
                window.console &&
                console.warn &&
                console.warn(
                  "A jQuery object with multiple elements was passed, using the first element.",
                ),
              (t = t[0])),
            "undefined" != typeof document &&
              "string" == typeof t &&
              (t = document.getElementById(t)),
            !li(t))
          )
            throw new TypeError(
              "You must pass either a valid element or a valid id.",
            );
          if ("IFRAME" !== t.nodeName) {
            var r = t.querySelector("iframe");
            r && (t = r);
          }
          if ("IFRAME" === t.nodeName && !fi(t.getAttribute("src") || ""))
            throw new Error("The player element passed isn’t a Vimeo embed.");
          if (Fi.has(t)) return Fi.get(t);
          (this._window = t.ownerDocument.defaultView),
            (this.element = t),
            (this.origin = "*");
          var o = new wi(function (e, r) {
            if (
              ((n._onMessage = function (t) {
                if (fi(t.origin) && n.element.contentWindow === t.source) {
                  "*" === n.origin && (n.origin = t.origin);
                  var i = Ci(t.data);
                  if (
                    i &&
                    "error" === i.event &&
                    i.data &&
                    "ready" === i.data.method
                  ) {
                    var o = new Error(i.data.message);
                    return (o.name = i.data.name), void r(o);
                  }
                  var s = i && "ready" === i.event,
                    a = i && "ping" === i.method;
                  if (s || a)
                    return n.element.setAttribute("data-ready", "true"), void e();
                  Ai(n, i);
                }
              }),
              n._window.addEventListener("message", n._onMessage),
              "IFRAME" !== n.element.nodeName)
            ) {
              var o = Mi(t, i);
              Ni(pi(o), o, t)
                .then(function (e) {
                  var i = Li(e, t);
                  return (
                    (n.element = i),
                    (n._originalElement = t),
                    Si(t, i),
                    Fi.set(n.element, n),
                    e
                  );
                })
                .catch(r);
            }
          });
          if (
            (ji.set(this, o),
            Fi.set(this.element, this),
            "IFRAME" === this.element.nodeName && xi(this, "ping"),
            Ii.isEnabled)
          ) {
            var s = function () {
              return Ii.exit();
            };
            (this.fullscreenchangeHandler = function () {
              Ii.isFullscreen
                ? _i(n, "event:exitFullscreen", s)
                : Pi(n, "event:exitFullscreen", s),
                n.ready().then(function () {
                  xi(n, "fullscreenchange", Ii.isFullscreen);
                });
            }),
              Ii.on("fullscreenchange", this.fullscreenchangeHandler);
          }
          return this;
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "callMethod",
              value: function (e) {
                var t = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                return new wi(function (i, r) {
                  return t
                    .ready()
                    .then(function () {
                      _i(t, e, { resolve: i, reject: r }), xi(t, e, n);
                    })
                    .catch(r);
                });
              },
            },
            {
              key: "get",
              value: function (e) {
                var t = this;
                return new wi(function (n, i) {
                  return (
                    (e = ci(e, "get")),
                    t
                      .ready()
                      .then(function () {
                        _i(t, e, { resolve: n, reject: i }), xi(t, e);
                      })
                      .catch(i)
                  );
                });
              },
            },
            {
              key: "set",
              value: function (e, t) {
                var n = this;
                return new wi(function (i, r) {
                  if (((e = ci(e, "set")), null == t))
                    throw new TypeError("There must be a value to set.");
                  return n
                    .ready()
                    .then(function () {
                      _i(n, e, { resolve: i, reject: r }), xi(n, e, t);
                    })
                    .catch(r);
                });
              },
            },
            {
              key: "on",
              value: function (e, t) {
                if (!e) throw new TypeError("You must pass an event name.");
                if (!t) throw new TypeError("You must pass a callback function.");
                if ("function" != typeof t)
                  throw new TypeError("The callback must be a function.");
                0 === ki(this, "event:".concat(e)).length &&
                  this.callMethod("addEventListener", e).catch(function () {}),
                  _i(this, "event:".concat(e), t);
              },
            },
            {
              key: "off",
              value: function (e, t) {
                if (!e) throw new TypeError("You must pass an event name.");
                if (t && "function" != typeof t)
                  throw new TypeError("The callback must be a function.");
                Pi(this, "event:".concat(e), t) &&
                  this.callMethod("removeEventListener", e).catch(
                    function (e) {},
                  );
              },
            },
            {
              key: "loadVideo",
              value: function (e) {
                return this.callMethod("loadVideo", e);
              },
            },
            {
              key: "ready",
              value: function () {
                var e =
                  ji.get(this) ||
                  new wi(function (e, t) {
                    t(new Error("Unknown player. Probably unloaded."));
                  });
                return wi.resolve(e);
              },
            },
            {
              key: "addCuePoint",
              value: function (e) {
                var t =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
                return this.callMethod("addCuePoint", { time: e, data: t });
              },
            },
            {
              key: "removeCuePoint",
              value: function (e) {
                return this.callMethod("removeCuePoint", e);
              },
            },
            {
              key: "enableTextTrack",
              value: function (e, t) {
                if (!e) throw new TypeError("You must pass a language.");
                return this.callMethod("enableTextTrack", {
                  language: e,
                  kind: t,
                });
              },
            },
            {
              key: "disableTextTrack",
              value: function () {
                return this.callMethod("disableTextTrack");
              },
            },
            {
              key: "pause",
              value: function () {
                return this.callMethod("pause");
              },
            },
            {
              key: "play",
              value: function () {
                return this.callMethod("play");
              },
            },
            {
              key: "requestFullscreen",
              value: function () {
                return Ii.isEnabled
                  ? Ii.request(this.element)
                  : this.callMethod("requestFullscreen");
              },
            },
            {
              key: "exitFullscreen",
              value: function () {
                return Ii.isEnabled
                  ? Ii.exit()
                  : this.callMethod("exitFullscreen");
              },
            },
            {
              key: "getFullscreen",
              value: function () {
                return Ii.isEnabled
                  ? wi.resolve(Ii.isFullscreen)
                  : this.get("fullscreen");
              },
            },
            {
              key: "requestPictureInPicture",
              value: function () {
                return this.callMethod("requestPictureInPicture");
              },
            },
            {
              key: "exitPictureInPicture",
              value: function () {
                return this.callMethod("exitPictureInPicture");
              },
            },
            {
              key: "getPictureInPicture",
              value: function () {
                return this.get("pictureInPicture");
              },
            },
            {
              key: "unload",
              value: function () {
                return this.callMethod("unload");
              },
            },
            {
              key: "destroy",
              value: function () {
                var e = this;
                return new wi(function (t) {
                  if (
                    (ji.delete(e),
                    Fi.delete(e.element),
                    e._originalElement &&
                      (Fi.delete(e._originalElement),
                      e._originalElement.removeAttribute(
                        "data-vimeo-initialized",
                      )),
                    e.element &&
                      "IFRAME" === e.element.nodeName &&
                      e.element.parentNode &&
                      (e.element.parentNode.parentNode &&
                      e._originalElement &&
                      e._originalElement !== e.element.parentNode
                        ? e.element.parentNode.parentNode.removeChild(
                            e.element.parentNode,
                          )
                        : e.element.parentNode.removeChild(e.element)),
                    e.element &&
                      "DIV" === e.element.nodeName &&
                      e.element.parentNode)
                  ) {
                    e.element.removeAttribute("data-vimeo-initialized");
                    var n = e.element.querySelector("iframe");
                    n &&
                      n.parentNode &&
                      (n.parentNode.parentNode &&
                      e._originalElement &&
                      e._originalElement !== n.parentNode
                        ? n.parentNode.parentNode.removeChild(n.parentNode)
                        : n.parentNode.removeChild(n));
                  }
                  e._window.removeEventListener("message", e._onMessage),
                    Ii.isEnabled &&
                      Ii.off("fullscreenchange", e.fullscreenchangeHandler),
                    t();
                });
              },
            },
            {
              key: "getAutopause",
              value: function () {
                return this.get("autopause");
              },
            },
            {
              key: "setAutopause",
              value: function (e) {
                return this.set("autopause", e);
              },
            },
            {
              key: "getBuffered",
              value: function () {
                return this.get("buffered");
              },
            },
            {
              key: "getCameraProps",
              value: function () {
                return this.get("cameraProps");
              },
            },
            {
              key: "setCameraProps",
              value: function (e) {
                return this.set("cameraProps", e);
              },
            },
            {
              key: "getChapters",
              value: function () {
                return this.get("chapters");
              },
            },
            {
              key: "getCurrentChapter",
              value: function () {
                return this.get("currentChapter");
              },
            },
            {
              key: "getColor",
              value: function () {
                return this.get("color");
              },
            },
            {
              key: "setColor",
              value: function (e) {
                return this.set("color", e);
              },
            },
            {
              key: "getCuePoints",
              value: function () {
                return this.get("cuePoints");
              },
            },
            {
              key: "getCurrentTime",
              value: function () {
                return this.get("currentTime");
              },
            },
            {
              key: "setCurrentTime",
              value: function (e) {
                return this.set("currentTime", e);
              },
            },
            {
              key: "getDuration",
              value: function () {
                return this.get("duration");
              },
            },
            {
              key: "getEnded",
              value: function () {
                return this.get("ended");
              },
            },
            {
              key: "getLoop",
              value: function () {
                return this.get("loop");
              },
            },
            {
              key: "setLoop",
              value: function (e) {
                return this.set("loop", e);
              },
            },
            {
              key: "setMuted",
              value: function (e) {
                return this.set("muted", e);
              },
            },
            {
              key: "getMuted",
              value: function () {
                return this.get("muted");
              },
            },
            {
              key: "getPaused",
              value: function () {
                return this.get("paused");
              },
            },
            {
              key: "getPlaybackRate",
              value: function () {
                return this.get("playbackRate");
              },
            },
            {
              key: "setPlaybackRate",
              value: function (e) {
                return this.set("playbackRate", e);
              },
            },
            {
              key: "getPlayed",
              value: function () {
                return this.get("played");
              },
            },
            {
              key: "getQualities",
              value: function () {
                return this.get("qualities");
              },
            },
            {
              key: "getQuality",
              value: function () {
                return this.get("quality");
              },
            },
            {
              key: "setQuality",
              value: function (e) {
                return this.set("quality", e);
              },
            },
            {
              key: "getSeekable",
              value: function () {
                return this.get("seekable");
              },
            },
            {
              key: "getSeeking",
              value: function () {
                return this.get("seeking");
              },
            },
            {
              key: "getTextTracks",
              value: function () {
                return this.get("textTracks");
              },
            },
            {
              key: "getVideoEmbedCode",
              value: function () {
                return this.get("videoEmbedCode");
              },
            },
            {
              key: "getVideoId",
              value: function () {
                return this.get("videoId");
              },
            },
            {
              key: "getVideoTitle",
              value: function () {
                return this.get("videoTitle");
              },
            },
            {
              key: "getVideoWidth",
              value: function () {
                return this.get("videoWidth");
              },
            },
            {
              key: "getVideoHeight",
              value: function () {
                return this.get("videoHeight");
              },
            },
            {
              key: "getVideoUrl",
              value: function () {
                return this.get("videoUrl");
              },
            },
            {
              key: "getVolume",
              value: function () {
                return this.get("volume");
              },
            },
            {
              key: "setVolume",
              value: function (e) {
                return this.set("volume", e);
              },
            },
          ]),
          n && ai(t.prototype, n),
          e
        );
      })();
    ui ||
      ((Ii = (function () {
        var e = (function () {
            for (
              var e,
                t = [
                  [
                    "requestFullscreen",
                    "exitFullscreen",
                    "fullscreenElement",
                    "fullscreenEnabled",
                    "fullscreenchange",
                    "fullscreenerror",
                  ],
                  [
                    "webkitRequestFullscreen",
                    "webkitExitFullscreen",
                    "webkitFullscreenElement",
                    "webkitFullscreenEnabled",
                    "webkitfullscreenchange",
                    "webkitfullscreenerror",
                  ],
                  [
                    "webkitRequestFullScreen",
                    "webkitCancelFullScreen",
                    "webkitCurrentFullScreenElement",
                    "webkitCancelFullScreen",
                    "webkitfullscreenchange",
                    "webkitfullscreenerror",
                  ],
                  [
                    "mozRequestFullScreen",
                    "mozCancelFullScreen",
                    "mozFullScreenElement",
                    "mozFullScreenEnabled",
                    "mozfullscreenchange",
                    "mozfullscreenerror",
                  ],
                  [
                    "msRequestFullscreen",
                    "msExitFullscreen",
                    "msFullscreenElement",
                    "msFullscreenEnabled",
                    "MSFullscreenChange",
                    "MSFullscreenError",
                  ],
                ],
                n = 0,
                i = t.length,
                r = {};
              n < i;
              n++
            )
              if ((e = t[n]) && e[1] in document) {
                for (n = 0; n < e.length; n++) r[t[0][n]] = e[n];
                return r;
              }
            return !1;
          })(),
          t = {
            fullscreenchange: e.fullscreenchange,
            fullscreenerror: e.fullscreenerror,
          },
          n = {
            request: function (t) {
              return new Promise(function (i, r) {
                var o = function e() {
                  n.off("fullscreenchange", e), i();
                };
                n.on("fullscreenchange", o);
                var s = (t = t || document.documentElement)[
                  e.requestFullscreen
                ]();
                s instanceof Promise && s.then(o).catch(r);
              });
            },
            exit: function () {
              return new Promise(function (t, i) {
                if (n.isFullscreen) {
                  var r = function e() {
                    n.off("fullscreenchange", e), t();
                  };
                  n.on("fullscreenchange", r);
                  var o = document[e.exitFullscreen]();
                  o instanceof Promise && o.then(r).catch(i);
                } else t();
              });
            },
            on: function (e, n) {
              var i = t[e];
              i && document.addEventListener(i, n);
            },
            off: function (e, n) {
              var i = t[e];
              i && document.removeEventListener(i, n);
            },
          };
        return (
          Object.defineProperties(n, {
            isFullscreen: {
              get: function () {
                return Boolean(document[e.fullscreenElement]);
              },
            },
            element: {
              enumerable: !0,
              get: function () {
                return document[e.fullscreenElement];
              },
            },
            isEnabled: {
              enumerable: !0,
              get: function () {
                return Boolean(document[e.fullscreenEnabled]);
              },
            },
          }),
          n
        );
      })()),
      (function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : document,
          t = [].slice.call(
            e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"),
          ),
          n = function (e) {
            "console" in window &&
              console.error &&
              console.error("There was an error creating an embed: ".concat(e));
          };
        t.forEach(function (e) {
          try {
            if (null !== e.getAttribute("data-vimeo-defer")) return;
            var t = Mi(e);
            Ni(pi(t), t, e)
              .then(function (t) {
                return Li(t, e);
              })
              .catch(n);
          } catch (e) {
            n(e);
          }
        });
      })(),
      (function () {
        var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : document;
        if (!window.VimeoPlayerResizeEmbeds_) {
          window.VimeoPlayerResizeEmbeds_ = !0;
          var t = function (t) {
            if (fi(t.origin) && t.data && "spacechange" === t.data.event)
              for (var n = e.querySelectorAll("iframe"), i = 0; i < n.length; i++)
                if (n[i].contentWindow === t.source) {
                  n[i].parentElement.style.paddingBottom = "".concat(
                    t.data.data[0].bottom,
                    "px",
                  );
                  break;
                }
          };
          window.addEventListener("message", t);
        }
      })(),
      (function () {
        var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : document;
        if (!window.VimeoSeoMetadataAppended) {
          window.VimeoSeoMetadataAppended = !0;
          var t = function (t) {
            if (fi(t.origin)) {
              var n = Ci(t.data);
              if (n && "ready" === n.event)
                for (
                  var i = e.querySelectorAll("iframe"), r = 0;
                  r < i.length;
                  r++
                ) {
                  var o = i[r],
                    s = o.contentWindow === t.source;
                  hi(o.src) &&
                    s &&
                    new Oi(o).callMethod(
                      "appendVideoMetadata",
                      window.location.href,
                    );
                }
            }
          };
          window.addEventListener("message", t);
        }
      })());
    const Ri = "//www.youtube.com/player_api";
    class Di {
      load(e) {
        if (window.YT && In(window.YT.Player)) return e();
        this.attachCallback(e),
          this.shouldLoad() &&
            Xn("script", { src: `${location.protocol}${Ri}` }, document.head);
      }
      shouldLoad() {
        return !((e = document), (t = "script"), Mn(e.querySelectorAll(t))).some(
          (e) => e.src.replace(/^https?:/, "") === Ri,
        );
        var e, t;
      }
      attachCallback(e) {
        let t;
        Rn(window.onYouTubeIframeAPIReady) ||
          (t = window.onYouTubeIframeAPIReady),
          (window.onYouTubeIframeAPIReady = () => {
            t && t(), e();
          });
      }
    }
    class Vi {
      constructor(e, t) {
        (this.event = Tn()),
          (this.Splide = e),
          (this.slide = t),
          (this.container = Wn(this.slide, ".splide__slide__container")),
          (this.parent = this.container || this.slide),
          this.init(),
          this.create(),
          this.show(),
          this.listen();
      }
      init() {
        qn(this.slide, "splide__slide--has-video"),
          qn(this.container, "splide__slide__container--has-video");
      }
      create() {
        (this.video = Xn("div", "splide__video", this.parent)),
          (this.playButton = Xn(
            "button",
            {
              class: "splide__video__play",
              type: "button",
              "aria-label": this.Splide.options.i18n.playVideo || "Play Video",
            },
            this.video,
          )),
          (this.wrapper = Xn("div", "splide__video__wrapper", this.video)),
          (this.placeholder = Xn("div", null, this.wrapper));
      }
      listen() {
        this.parent.addEventListener("click", () => {
          this.event.emit("click");
        });
      }
      toggleButton(e) {
        Gn(this.playButton, e ? "" : "none");
      }
      toggleWrapper(e) {
        Gn(this.wrapper, e ? "" : "none");
      }
      getPlaceholder() {
        return this.placeholder;
      }
      hide() {
        this.toggleButton(!1), this.toggleWrapper(!0);
      }
      show() {
        this.disabled || this.toggleButton(!0), this.toggleWrapper(!1);
      }
      disable(e) {
        (this.disabled = e), e && this.toggleButton(!1);
      }
      on(e, t) {
        this.event.on(e, t);
      }
      destroy() {
        Qn(this.slide, "splide__slide--has-video"),
          Qn(this.container, "splide__slide__container--has-video"),
          Vn(this.video, (e) => {
            e && e.parentNode && e.parentNode.removeChild(e);
          }),
          this.event.destroy();
      }
    }
    const zi = [
      [
        "data-splide-youtube",
        class extends oi {
          constructor(e, t, n = {}) {
            super(e, t, n),
              (this.videoId = this.parseVideoId(t)),
              this.videoId &&
                (this.state.set(2), new Di().load(this.onAPIReady.bind(this)));
          }
          onAPIReady() {
            const { state: e } = this,
              t = e.is(4);
            e.set(3), t && this.play();
          }
          createPlayer(e) {
            const {
              options: t,
              options: { playerOptions: n = {} },
            } = this;
            return new YT.Player(this.target, {
              videoId: e,
              host: t.host,
              playerVars: Yn(
                {
                  controls: t.hideControls ? 0 : 1,
                  iv_load_policy: 3,
                  loop: t.loop ? 1 : 0,
                  playlist: t.loop ? e : void 0,
                  rel: 0,
                  autoplay: 0,
                  mute: t.mute ? 1 : 0,
                },
                n.youtube || {},
              ),
              events: {
                onReady: this.onPlayerReady.bind(this),
                onStateChange: this.onPlayerStateChange.bind(this),
                onError: this.onError.bind(this),
              },
            });
          }
          onPlayerReady() {
            super.onPlayerReady(),
              this.player.setVolume(100 * ni(this.options.volume, 0, 1));
          }
          onPlayerStateChange(e) {
            const { PLAYING: t, PAUSED: n, ENDED: i } = YT.PlayerState;
            switch (!0) {
              case e.data === t:
                this.onPlay();
                break;
              case e.data === n:
                this.onPause();
                break;
              case e.data === i:
                this.onEnded();
            }
          }
          playVideo() {
            this.player.playVideo();
          }
          pauseVideo() {
            this.player.pauseVideo();
          }
          parseVideoId(e) {
            return 0 === e.indexOf("http") ? this.parseUrl(e) : e;
          }
          parseUrl(e) {
            const [, t] = e.split(/[#?]/),
              n =
                ((i = (e) => 0 === e.indexOf("v=")),
                Mn(t.split("&")).filter(i)[0]);
            var i;
            return n && n.replace("v=", "");
          }
        },
      ],
      [
        "data-splide-vimeo",
        class extends oi {
          constructor(e, t, n = {}) {
            super(e, t, n), this.state.set(3);
          }
          createPlayer(e) {
            const {
                options: t,
                options: { playerOptions: n = {} },
              } = this,
              i = 0 === e.indexOf("http") ? { url: e } : { id: +e },
              r = new Oi(
                this.target,
                Yn(
                  i,
                  { controls: !t.hideControls, loop: t.loop, muted: t.mute },
                  n.vimeo || {},
                ),
              );
            return (
              r.on("play", this.onPlay),
              r.on("pause", this.onPause),
              r.on("ended", this.onEnded),
              r.ready().then(this.onPlayerReady, this.onError),
              r.getMuted() || r.setVolume(ni(t.volume, 0, 1)),
              r
            );
          }
          playVideo() {
            this.player.play().catch(() => {
              this.state.is(7) && this.state.set(5);
            });
          }
          pauseVideo() {
            this.player.pause();
          }
        },
      ],
      [
        "data-splide-html-video",
        class extends oi {
          constructor(e, t, n = {}) {
            super(e, t, n), this.state.set(3);
          }
          createPlayer(e) {
            const {
                options: t,
                options: { playerOptions: n = {} },
              } = this,
              i = Xn("video", { src: e }, this.target),
              r = i.addEventListener.bind(i);
            return (
              Yn(
                i,
                {
                  controls: !t.hideControls,
                  loop: t.loop,
                  volume: ni(t.volume, 0, 1),
                  muted: t.mute,
                },
                n.htmlVideo || {},
              ),
              r("play", this.onPlay),
              r("pause", this.onPause),
              r("ended", this.onEnded),
              r("loadeddata", this.onPlayerReady),
              r("error", this.onError),
              i
            );
          }
          playVideo() {
            const e = this.player.play();
            e && e.catch(this.onError.bind(this));
          }
          pauseVideo() {
            this.player.pause();
          }
          onError() {
            this.state.is(7) ? this.state.set(5) : super.onError();
          }
          destroy() {
            super.destroy();
            const { player: e } = this,
              t = e.addEventListener.bind(e);
            t("play", this.onPlay),
              t("pause", this.onPause),
              t("ended", this.onEnded),
              t("loadeddata", this.onPlayerReady);
          }
        },
      ],
    ];
    class qi {
      constructor(e, t) {
        (this.Splide = e),
          (this.slide = t),
          (this.event = Tn(e)),
          (this.options = Hn(Hn({}, ii), this.Splide.options.video)),
          this.createPlayer(t),
          this.player && this.listen();
      }
      createPlayer(e) {
        zi.forEach(([t, n]) => {
          const i = (function (e, t) {
            return e.getAttribute(t);
          })(e, t);
          i &&
            ((this.ui = new Vi(this.Splide, e)),
            (this.player = new n(this.ui.getPlaceholder(), i, this.options)),
            this.ui.disable(this.options.disableOverlayUI));
        });
      }
      listen() {
        const { player: e, event: t } = this;
        this.ui.on("click", this.onClick.bind(this)),
          e.on("play", this.onPlay.bind(this)),
          e.on("played", this.onPlayed.bind(this)),
          e.on("pause", this.onPause.bind(this)),
          e.on("paused", this.onPaused.bind(this)),
          e.on("ended", this.onEnded.bind(this)),
          e.on("error", this.onError.bind(this)),
          t.on(["move", "scroll"], this.pause.bind(this)),
          t.on(ri, this.onVideoClick.bind(this)),
          t.on("drag", () => {
            t.off(An),
              t.on(An, () => {
                this.pause(), t.off(An);
              });
          }),
          this.options.autoplay &&
            t.on(
              ["mounted", "moved", "scrolled"],
              this.onAutoplayRequested.bind(this),
            );
      }
      onClick() {
        this.isPaused() ? this.play() : this.pause(), this.event.emit(ri, this);
      }
      onVideoClick(e) {
        this !== e && this.pause();
      }
      onPlay() {
        this.ui.hide();
      }
      onPlayed() {
        this.ui.hide(),
          this.togglePlaying(!0),
          this.event.emit("video:play", this);
      }
      onPause() {
        this.ui.show();
      }
      onPaused() {
        this.togglePlaying(!1), this.event.emit("video:pause", this);
      }
      onEnded() {
        this.togglePlaying(!1), this.event.emit("video:ended", this);
      }
      onError() {
        qn(this.slide, "is-error"),
          this.ui.show(),
          this.event.emit("video:error", this);
      }
      onAutoplayRequested() {
        this.Splide.Components.Slides.getAt(this.Splide.index).slide ===
          this.slide && this.play();
      }
      togglePlaying(e) {
        zn(this.Splide.root, "is-playing", e);
      }
      play() {
        this.player && !this.disabled && this.player.play();
      }
      pause() {
        this.player && !this.disabled && this.player.pause();
      }
      destroy() {
        this.player && (this.ui.destroy(), this.player.destroy()),
          this.disable(!1);
      }
      disable(e) {
        (this.disabled = e), zn(this.Splide.root, "is-video-disabled", e);
      }
      isPaused() {
        return this.player.isPaused();
      }
    }
    function Wi(e, t) {
      const { on: n } = Tn(e),
        { Slides: i } = t,
        r = {};
      function o() {
        i.forEach((t) => {
          const { slide: n } = t;
          var i;
          ((i = n) && i.classList.contains("splide__slide--has-video")) ||
            (r[t.index] = new qi(e, n));
        }),
          i.update();
      }
      return {
        mount: function () {
          o(), n("refresh", o);
        },
        destroy: function () {
          Bn(r, (e) => {
            e.destroy();
          });
        },
        play: function (t = e.index) {
          const n = r[t];
          n && n.play();
        },
        pause: function () {
          Bn(r, (e) => {
            e.pause();
          });
        },
        disable: function (e) {
          Bn(r, (t) => {
            t.disable(e);
          });
        },
      };
    }
    (window.SuperDawn.initSlider = (e, t = {}) =>
      new Mt(e, Object.assign({}, { type: "loop", pagination: !1 }, t)).mount({
        Grid: bn,
      })),
      (window.SuperDawn.initAnnouncementSlider = (e, t = {}) =>
        new Mt(e, Object.assign({}, { type: "loop", pagination: !1 }, t))),
      (window.SuperDawn.initProductSlider = (e, t = {}) =>
        new Mt(e, Object.assign({}, { type: "loop", pagination: !1 }, t))),
      (window.SuperDawn.initHeroSlider = (e, t = {}) =>
        new Mt(e, Object.assign({}, { pagination: !1 }, t))),
      (window.SuperDawn.checkReadyAndMount = (e, t, n, i) => {
        e.on("ready", () => {
          document.querySelector(t).classList.remove("h-0", "invisible"),
            document.querySelector(n).classList.add(i);
        }),
          e.mount();
      }),
      (window.SuperDawn.checkReadyAndMountHeroSlider = (e) => {
        e.on("ready", () => {
          document
            .querySelector(".hero-slider.splide")
            .classList.remove("h-0", "invisible"),
            document.querySelector(".slider-preload").classList.add("hidden");
        }),
          e.mount({ Video: Wi });
      });
  })();
  